<template>
  <div class="add-mall-top" id="addMallTop">
    <second-menu-link-content>
      <template v-slot:header>
        <span>顶部导航</span>
      </template>
      <template v-slot:content>
        <div class="titles" :class="isEditingColumn ? 'edit-bar' : 'edit-page'" ref="titles">
          <div class="container left" @click="onEditBar">
            <span class="title">1.栏目编辑</span>
          </div>
          <div class="container right" @click="onEditPage" v-if="editedColumnId">
            <span class="title">2.页面编辑</span>
          </div>
        </div>
        <div class="bar-edit-container" v-show="isEditingColumn">
          <el-form ref="columnInfo" :model="columnInfo" :rules="columnInfoRules" label-width="80">
            <el-form-item class="item" label="栏目名称：" prop="barName">
              <el-input
                class="white"
                @input="getCharLength(columnInfo.barName)"
                v-model="columnInfo.barName"
                placeholder="请输入名称(最多12字节)"
              ></el-input>
            </el-form-item>
            <el-form-item class="item" label="栏目路径：" prop="barPath">
              <el-input class="white" v-model="columnInfo.barPath" placeholder="请输入路径"></el-input>
            </el-form-item>
            <el-form-item class="item" label="是否启用：" prop="status">
              <template>
                <el-radio v-model="columnInfo.status" :label="1">启用</el-radio>
                <el-radio v-model="columnInfo.status" :label="0">禁用</el-radio>
              </template>
            </el-form-item>
            <el-form-item class="item" label="游客是否可见：" prop="isTouristsVisible">
              <template>
                <el-radio v-model="columnInfo.isTouristsVisible" :label="1">启用</el-radio>
                <el-radio v-model="columnInfo.isTouristsVisible" :label="0">禁用</el-radio>
              </template>
            </el-form-item>
          </el-form>
          <div class="operations" ref="operations">
            <el-button class="btn-white" @click="cancelColumnInfo">取消</el-button>
            <el-button class="btn-blue" @click="saveColumnInfo">保存</el-button>
          </div>
        </div>
        <div class="page-edit-container" v-show="isEditingModule">
          <div class="module-edit">
            <div class="module-area">
              <div class="modules" ref="modules">
                <!-- 复制节点的源节点--大模块 -->
                <div class="module-tpl-container" v-show="false">
                  <div class="big-module module-tpl" ref="bigModule">
                    <div class="big-module-content">
                      <!-- 大模块--非预览模式 -->
                      <div class="btn-desc">点击编辑大模块</div>
                      <!-- 大模块--海报图预览 -->
                      <img
                        class="prev-img-poster"
                        style="display: none;"
                        width="540"
                        height="180"
                        src="#"
                      />
                      <!-- 大模块--轮播图首图预览 -->
                      <img
                        class="prev-img-carousel"
                        style="display: none;"
                        width="540"
                        height="180"
                        src="#"
                      />
                      <!-- 大模块--横幅条预览 -->
                      <img
                        class="prev-img-banner"
                        style="display: none;"
                        width="600"
                        height="40"
                        src="#"
                      />
                      <!-- 大模块--商品预览--根据选择数量来展示 -->
                      <ul class="preview-commodity-list" style="display: none;">
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="100" height="100" src="#" />
                          <p class="commodity-name"></p>
                          <span class="commodity-price"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="100" height="100" src="#" />
                          <p class="commodity-name"></p>
                          <span class="commodity-price"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="100" height="100" src="#" />
                          <p class="commodity-name"></p>
                          <span class="commodity-price"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="100" height="100" src="#" />
                          <p class="commodity-name"></p>
                          <span class="commodity-price"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="100" height="100" src="#" />
                          <p class="commodity-name"></p>
                          <span class="commodity-price"></span>
                        </li>
                      </ul>
                      <!-- 大模块--促销商品预览--轮播 -->
                      <div class="preview-promotion-container" style="display: none;">
                        <div class="desc-container">
                          <div class="desc">限时促销</div>
                          <div class="btn-desc">
                            <span class="previous"></span>
                            <span class="next"></span>
                          </div>
                        </div>
                        <ul class="preview-promotion-list" style="display: flex;">
                          <li class="preview-commodity" style="display: none;">
                            <img class="commodity-img" width="80" height="80" src="#" />
                            <p class="commodity-name"></p>
                          </li>
                          <li class="preview-commodity" style="display: none;">
                            <img class="commodity-img" width="80" height="80" src="#" />
                            <p class="commodity-name"></p>
                          </li>
                          <li class="preview-commodity" style="display: none;">
                            <img class="commodity-img" width="80" height="80" src="#" />
                            <p class="commodity-name"></p>
                          </li>
                          <li class="preview-commodity" style="display: none;">
                            <img class="commodity-img" width="80" height="80" src="#" />
                            <p class="commodity-name"></p>
                          </li>
                          <li class="preview-commodity" style="display: none;">
                            <img class="commodity-img" width="80" height="80" src="#" />
                            <p class="commodity-name"></p>
                          </li>
                        </ul>
                      </div>
                      <!-- 大模块--富文本预览 -->
                      <div class="preview-rich-text" style="display: none;"></div>
                    </div>
                    <div class="big-module-delete-btn">x</div>
                  </div>
                </div>
                <!-- 复制节点的源节点--小模块 -->
                <div class="module-tpl-container" v-show="false">
                  <div class="small-module module-tpl" ref="smallModule">
                    <div class="small-module-child one">
                      <!-- 小模块--非预览模式 -->
                      <div class="btn-desc">点击编辑小模块</div>
                      <!-- 小模块--海报图预览--一张海报图 -->
                      <img
                        class="preview-poster-img"
                        style="display: none;"
                        width="180"
                        height="180"
                        src="#"
                      />
                      <!-- 小模块--海报图预览--两张海报图 -->
                      <div class="preview-poster-img-container" style="display: none;">
                        <img class="preview-poster-img" width="180" height="88" src="#" />
                        <img class="preview-poster-img" width="180" height="88" src="#" />
                      </div>
                      <!-- 小模块--轮播图首图预览 -->
                      <img
                        class="preview-carousel-img"
                        style="display: none;"
                        width="188"
                        height="184"
                        src="#"
                      />
                      <!-- 小模块--商品编辑预览 -->
                      <ul class="preview-commodity-list" style="display: none;">
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name"></span>
                        </li>
                      </ul>
                    </div>
                    <div class="small-module-child two">
                      <!-- 小模块--非预览模式 -->
                      <div class="btn-desc">点击编辑小模块</div>
                      <!-- 小模块--海报图预览--一张海报图 -->
                      <img
                        class="preview-poster-img"
                        style="display: none;"
                        width="180"
                        height="180"
                        src="#"
                      />
                      <!-- 小模块--海报图预览--两张海报图 -->
                      <div class="preview-poster-img-container" style="display: none;">
                        <img class="preview-poster-img" width="180" height="88" src="#" />
                        <img class="preview-poster-img" width="180" height="88" src="#" />
                      </div>
                      <!-- 小模块--轮播图首图预览 -->
                      <img
                        class="preview-carousel-img"
                        style="display: none;"
                        width="188"
                        height="184"
                        src="#"
                      />
                      <!-- 小模块--商品编辑预览 -->
                      <ul class="preview-commodity-list" style="display: none;">
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name"></span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name"></span>
                        </li>
                      </ul>
                    </div>
                    <div class="small-module-child three">
                      <!-- 小模块--非预览模式 -->
                      <div class="btn-desc">点击编辑小模块</div>
                      <!-- 小模块--海报图预览--一张海报图 -->
                      <img
                        class="preview-poster-img"
                        style="display: none;"
                        width="180"
                        height="180"
                        src="#"
                      />
                      <!-- 小模块--海报图预览--两张海报图 -->
                      <div class="preview-poster-img-container" style="display: none;">
                        <img class="preview-poster-img" width="180" height="88" src="#" />
                        <img class="preview-poster-img" width="180" height="88" src="#" />
                      </div>
                      <!-- 小模块--轮播图首图预览 -->
                      <img
                        class="preview-carousel-img"
                        style="display: none;"
                        width="188"
                        height="184"
                        src="#"
                      />
                      <!-- 小模块--商品编辑预览 -->
                      <ul class="preview-commodity-list" style="display: none;">
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name">华为HUAWEI......</span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name">华为HUAWEI......</span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name">华为HUAWEI......</span>
                        </li>
                        <li class="preview-commodity" style="display: none;">
                          <img class="commodity-img" width="54" height="54" src="#" />
                          <span class="commodity-name">华为HUAWEI......</span>
                        </li>
                      </ul>
                    </div>
                    <div class="small-module-delete-btn">x</div>
                  </div>
                </div>
                <!-- 大模块编辑框 -->
                <div
                  class="big-module-edit-box"
                  ref="bigModuleEditBox"
                  v-show="isShowBigModuleEditBox"
                >
                  <span class="desc">编辑模块</span>
                  <div class="module-type">
                    <span class="desc">添加类型：</span>
                    <el-radio-group v-model="bigModuleInfoType">
                      <el-radio class="item" :label="moduleInfoTypeEnum.picture">图片</el-radio>
                      <el-radio class="item" :label="moduleInfoTypeEnum.generalGood">商品</el-radio>
                      <el-radio class="item" :label="moduleInfoTypeEnum.promotionalGood">促销</el-radio>
                      <el-radio class="item" :label="moduleInfoTypeEnum.richText">富文本</el-radio>
                    </el-radio-group>
                  </div>
                  <!-- 图片类型 -->
                  <div
                    class="module-type-image"
                    v-show="bigModuleInfoType === moduleInfoTypeEnum.picture"
                  >
                    <div class="image-type">
                      <span class="desc">图片类型：</span>
                      <el-radio-group v-model="bigModuleInfoImgType">
                        <el-radio :label="moduleImgInfoTypes.poster">海报图</el-radio>
                        <el-radio :label="moduleImgInfoTypes.carousel">轮播图</el-radio>
                        <el-radio :label="moduleImgInfoTypes.banner">横幅条</el-radio>
                      </el-radio-group>
                    </div>
                    <!-- 添加海报图 -->
                    <div
                      class="poster-banner-img-upload-area"
                      v-show="
                        bigModuleInfoImgType === moduleImgInfoTypes.poster
                      "
                    >
                      <div
                        class="el-upload-container"
                        v-show="bigModulePosterModel.moduleInfo.data[0].editImg"
                      >
                        <el-upload
                          action="#"
                          drag
                          ref="bigModulePoster"
                          class="img-uploader"
                          accept="image/jpeg, image/png, image/jpg"
                          :multiple="false"
                          :show-file-list="false"
                          :on-change="bigModulePosterChange"
                          :before-upload="beforeUploadBigModulePosterImg"
                          :http-request="uploadBigModulePosterImg"
                        >
                          <div class="el-upload__text">+添加图片</div>
                        </el-upload>
                      </div>
                      <div
                        class="pre-img-container"
                        v-show="
                          !bigModulePosterModel.moduleInfo.data[0].editImg
                        "
                        @click="
                          bigModulePosterModel.moduleInfo.data[0].editImg = true
                        "
                      >
                        <img
                          width="150"
                          height="50"
                          class="pre-img"
                          :src="bigModulePosterModel.moduleInfo.data[0].imgSrc"
                          alt="图片"
                        />
                      </div>
                      <div class="add-link">
                        <span class="desc">添加链接：</span>
                        <el-input
                          class="gray"
                          v-model="
                            bigModulePosterModel.moduleInfo.data[0].linkSrc
                          "
                          placeholder="请输入链接"
                        ></el-input>
                      </div>
                      <div class="tip">建议尺寸1200*400px</div>
                    </div>
                    <!-- 添加横幅条图 -->
                    <div
                      class="poster-banner-img-upload-area"
                      v-show="
                        bigModuleInfoImgType === moduleImgInfoTypes.banner
                      "
                    >
                      <div
                        class="el-upload-container"
                        v-show="bigModuleBannerModel.moduleInfo.data[0].editImg"
                      >
                        <el-upload
                          action="#"
                          ref="bigModuleBanner"
                          drag
                          class="img-uploader"
                          accept="image/jpeg, image/png, image/jpg"
                          :multiple="false"
                          :show-file-list="false"
                          :on-change="bigModuleBannerChange"
                          :before-upload="beforeUploadBigModuleBannerImg"
                          :http-request="uploadBigModuleBannerImg"
                        >
                          <div class="el-upload__text">+添加图片</div>
                        </el-upload>
                      </div>
                      <div
                        class="pre-img-container"
                        v-show="
                          !bigModuleBannerModel.moduleInfo.data[0].editImg
                        "
                        @click="
                          bigModuleBannerModel.moduleInfo.data[0].editImg = true
                        "
                      >
                        <img
                          width="150"
                          height="50"
                          class="pre-img"
                          :src="bigModuleBannerModel.moduleInfo.data[0].imgSrc"
                          alt="图片"
                        />
                      </div>
                      <div class="add-link">
                        <span class="desc">添加链接：</span>
                        <el-input
                          class="gray"
                          v-model="
                            bigModuleBannerModel.moduleInfo.data[0].linkSrc
                          "
                          placeholder="请输入链接"
                        ></el-input>
                      </div>
                      <div class="tip">建议尺寸1200*80px</div>
                    </div>
                    <!-- 轮播图 -->
                    <div
                      class="carousel-img-upload-area"
                      v-for="(item, index) in bigModuleCarouselModel.moduleInfo
                        .data"
                      :key="index"
                      v-show="
                        bigModuleInfoImgType === moduleImgInfoTypes.carousel
                      "
                      ref="carouselImgUpload"
                    >
                      <div
                        class="el-upload-container"
                        v-show="item.editImg"
                        @click="onBigModuleCarouselClick(index)"
                      >
                        <el-upload
                          v-if="item.editImg"
                          action="#"
                          drag
                          ref="bigModuleCarousel"
                          :on-change="bigModuleCarouselChange"
                          :before-upload="beforeUploadBigModuleCarouselImg"
                          :http-request="uploadBigModuleCarouselImg"
                          :limit="1"
                        >
                          <div class="el-upload__text">+添加图片</div>
                        </el-upload>
                      </div>
                      <div
                        class="pre-img-container"
                        v-show="!item.editImg"
                        @click="item.editImg = true"
                      >
                        <img class="uploaded-img" :src="item.imgSrc" alt="图片" />
                      </div>
                      <div class="banner-foot">
                        <div class="add-link">
                          <span class="desc">添加链接：</span>
                          <el-input class="gray" v-model="item.linkSrc" placeholder="请输入链接"></el-input>
                        </div>
                        <div class="sort">
                          <el-button class="btn-text" :disabled="index==0" type="text" @click="prev(index, item)">上移</el-button>
                          <el-button class="btn-text" :disabled="index==bigModuleCarouselModel.moduleInfo.data.length-1" type="text" @click="next(index, item)">下移</el-button>
                        </div>
                      </div>
                      <div class="delete-btn" @click="deleteBigModuleCarouselImg(index)">x</div>
                    </div>
                    <div
                      class="btn-tip"
                      v-show="
                        bigModuleInfoImgType === moduleImgInfoTypes.carousel
                      "
                    >
                      <span class="btn" @click="addBigModuleCarouselImg">新增</span>
                      <span class="tip">最多插入六张图片，建议尺寸1000*400px，如果不放置首位建议尺寸1200*400</span>
                    </div>
                  </div>
                  <!-- 商品类型--普通商品+促销商品 -->
                  <div
                    class="module-type-commodity"
                    v-show="
                      bigModuleInfoType === moduleInfoTypeEnum.generalGood ||
                        bigModuleInfoType === moduleInfoTypeEnum.promotionalGood
                    "
                  >
                    <div class="commodity-area">
                      <div class="table-img">
                        <el-table
                          class="table-container"
                          :data="bigModuleCommodityModel.moduleInfo.data"
                          height="250"
                        >
                          <el-table-column label="商品名称" width="280">
                            <template slot-scope="props">
                              <img
                                class="img"
                                width="56"
                                height="56"
                                :src="props.row.commodityImg"
                                alt="人"
                              />
                              <p class="name">{{ props.row.commodityName }}</p>
                            </template>
                          </el-table-column>
                          <el-table-column label="操作">
                            <template slot-scope="props">
                              <span class="delete-btn" @click="deleteBigModuleCommodity(props)">删除</span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <span class="add-btn" @click="bigModuleAddCommodity">添加商品</span>
                    </div>
                  </div>
                  <!-- 富文本类型 -->
                  <div
                    class="module-type-richtext"
                    v-show="bigModuleInfoType === moduleInfoTypeEnum.richText"
                  >
                    <editor
                      :catchData="catchData"
                      :content="bigModuleRichtextModel.moduleInfo.data"
                    ></editor>
                  </div>
                  <div class="cancel-save-btns">
                    <el-button class="btn-white" @click="cancelBigModuleEdit">取消</el-button>
                    <el-button class="btn-blue" @click="saveBigModuleEdit">保存</el-button>
                  </div>
                </div>
                <!-- 小模块编辑框 -->
                <div
                  class="small-module-edit-box"
                  ref="smallModuleEditBox"
                  v-show="isShowSmallModuleEditBox"
                >
                  <span class="desc">编辑模块</span>
                  <div class="module-type">
                    <span class="desc">添加类型：</span>
                    <el-radio-group v-model="smallModuleInfoType">
                      <el-radio :label="moduleInfoTypeEnum.picture">图片</el-radio>
                      <el-radio :label="moduleInfoTypeEnum.generalGood">商品</el-radio>
                    </el-radio-group>
                  </div>
                  <div
                    class="module-type-image"
                    v-show="smallModuleInfoType === moduleInfoTypeEnum.picture"
                  >
                    <div class="image-type">
                      <span class="desc">图片类型：</span>
                      <el-radio-group v-model="smallModuleImgInfoType">
                        <el-radio :label="moduleImgInfoTypes.poster">海报图</el-radio>
                        <el-radio :label="moduleImgInfoTypes.carousel">轮播图</el-radio>
                      </el-radio-group>
                    </div>
                    <div
                      class="image-count"
                      v-show="
                        smallModuleImgInfoType === moduleImgInfoTypes.poster
                      "
                    >
                      <span class="desc">图片个数：</span>
                      <el-radio-group
                        v-model="smallModuleImgNum"
                        @change="onSmallModuleImgNumChange"
                      >
                        <el-radio :label="1">1</el-radio>
                        <el-radio :label="2">2</el-radio>
                      </el-radio-group>
                    </div>
                    <!-- 添加海报图 -->
                    <div
                      class="poster-img-upload-area"
                      v-show="
                        smallModuleImgInfoType === moduleImgInfoTypes.poster
                      "
                    >
                      <div
                        class="img-upload-container"
                        v-for="(item, index) in smallModulePosterModel
                          .moduleInfo.data"
                        :key="index"
                      >
                        <div
                          class="el-upload-container"
                          v-show="item.editImg"
                          @click="onSmallModulePosterClick(index)"
                        >
                          <el-upload
                            class="small-edit-box"
                            action="#"
                            ref="smallModulePosterImgOne"
                            drag
                            :multiple="false"
                            :show-file-list="false"
                            :on-change="onSmallModulePosterImgChange"
                            :before-upload="beforeUploadSmallModulePosterImg"
                            :http-request="uploadSmallModulePosterImg"
                          >
                            <div class="el-upload__text">+添加图片</div>
                          </el-upload>
                        </div>
                        <div
                          class="pre-img-container"
                          v-show="!item.editImg"
                          @click="item.editImg = true"
                        >
                          <img
                            class="uploaded-img"
                            :src="item.imgSrc"
                            alt="已经上传的图片"
                            width="120"
                            height="120"
                          />
                        </div>
                        <div class="link-tip-container">
                          <div class="add-link">
                            <span class="desc">添加链接：</span>
                            <el-input class="gray" v-model="item.linkSrc" placeholder="请输入链接"></el-input>
                          </div>
                          <div class="tip">建议尺寸360*225px</div>
                        </div>
                      </div>
                    </div>
                    <!-- 轮播图 -->
                    <div
                      class="carousel-img-upload-area"
                      v-for="(item, index) in smallModuleCarouselModel
                        .moduleInfo.data"
                      :key="index"
                      v-show="
                        smallModuleImgInfoType === moduleImgInfoTypes.carousel
                      "
                      ref="carouselImgUpload"
                    >
                      <div
                        class="el-upload-container"
                        v-show="item.editImg"
                        @click="onSmallModuleCarouselClick(index)"
                      >
                        <el-upload
                          v-if="item.editImg"
                          action="#"
                          drag
                          ref="smallModuleCarousel"
                          :multiple="false"
                          :show-file-list="false"
                          :on-change="smallModuleCarouselChange"
                          :before-upload="beforeUploadSmallModuleCarouselImg"
                          :http-request="uploadSmallModuleCarouselImg"
                          :limit="1"
                        >
                          <div class="el-upload__text">+添加图片</div>
                        </el-upload>
                      </div>
                      <!-- 图片上传成功的预览图 -->
                      <div
                        class="pre-img-container"
                        v-show="!item.editImg"
                        @click="item.editImg = true"
                      >
                        <img class="img-uploaded" :src="item.imgSrc" alt="图片" />
                      </div>
                      <div class="add-link">
                        <span class="desc">添加链接：</span>
                        <el-input class="gray" v-model="item.linkSrc" placeholder="请输入链接"></el-input>
                      </div>
                      <div class="delete-btn" @click="deleteSmallModuleCarouselImg(index)">x</div>
                    </div>
                    <div
                      class="btn-tip"
                      v-show="
                        smallModuleImgInfoType === moduleImgInfoTypes.carousel
                      "
                    >
                      <span class="btn" @click="addSmallModuleCarouselImg">新增</span>
                      <span class="tip">最多插入三张图片，建议尺寸400*500px</span>
                    </div>
                  </div>
                  <div
                    class="module-type-commodity"
                    v-show="
                      smallModuleInfoType === moduleInfoTypeEnum.generalGood
                    "
                  >
                    <div class="commodity-area">
                      <div class="table-img">
                        <el-table
                          class="table-container"
                          :data="smallModuleCommodityModel.moduleInfo.data"
                          height="250"
                        >
                          <el-table-column label="商品名称" width="280">
                            <template slot-scope="props">
                              <img
                                class="img"
                                width="56"
                                height="56"
                                :src="props.row.commodityImg"
                                alt="人"
                              />
                              <p class="name">{{ props.row.commodityName }}</p>
                            </template>
                          </el-table-column>
                          <el-table-column label="操作">
                            <template slot-scope="props">
                              <span class="delete-btn" @click="deleteSmallModuleCommodity(props)">删除</span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <span class="add-btn" @click="smallModuleAddCommodity">添加商品</span>
                    </div>
                  </div>
                  <div class="cancel-save-btns">
                    <el-button class="btn-white" @click="cancelSmallModuleEdit">取消</el-button>
                    <el-button class="btn-blue" @click="saveSmallModuleEdit">保存</el-button>
                  </div>
                </div>
              </div>
              <!-- 左侧添加模块按钮 -->
              <div class="add-module">
                <span class="desc">添加框架</span>
                <div class="line"></div>
                <div class="module-list">
                  <div class="add-big-module" ref="addBigModuleBtn" @click="addBigModule"></div>
                  <div class="add-small-module" ref="addSmallModuleBtn" @click="addSmallModule">
                    <div class="item"></div>
                    <div class="item"></div>
                    <div class="item"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 右侧编辑框的背景墙 -->
            <div class="edit-area"></div>
          </div>
          <!-- 添加商品--弹框 -->
          <el-dialog
            class="add-commodity-container"
            title="添加商品"
            :visible.sync="isShowGoodModal"
            width="1200px"
            top="25vh"
          >
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <div class="select-search-container">
              <el-cascader
                class="commodity-type"
                v-model="selectedGoodsType"
                :options="goodsTypeList"
                :props="goodsTypeListProps"
                placeholder="选择商品分类"
                clearable
              ></el-cascader>
              <el-input
                class="gray"
                placeholder="请输入商品名称"
                @keyup.enter.native="filterCommodity"
                v-model="goodsQuery"
              ></el-input>
              <el-button class="btn-blue" @click="filterCommodity">筛选</el-button>
            </div>
            <div class="table-img">
              <el-table
                class="table-container"
                :data="goodsList"
                ref="commodityListTable"
                height="250"
              >
                <el-table-column label="选择商品" width="120px">
                  <template slot-scope="props">
                    <el-checkbox v-model="props.row.isSelected"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="商品图片" prop="commodityImg">
                  <template slot-scope="props">
                    <img class="img" width="20" height="20" :src="props.row.commodityImg" alt="商品图" />
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="commodityName">
                  <template slot-scope="props">
                    <p class="name">{{ props.row.commodityName }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="商品分类" prop="commodityClassify">
                  <template slot-scope="props">
                    <div class="commodity-classify">{{ props.row.commodityClassify }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="零售价" prop="retailPrice"></el-table-column>
                <el-table-column :label="goodsTableNumDesc" prop="ableInventory"></el-table-column>
              </el-table>
            </div>
            <div class="pagination-container">
              <pagination-tpl
                @queryChange="handleQueryChange"
                :total="totalCountOfGoods"
                :currentPage="currentPageOfGoods"
              ></pagination-tpl>
            </div>
            <div class="commodity-operations">
              <el-button class="btn-white" @click="removeModuleCommodity">取消</el-button>
              <el-button class="btn-blue" @click="saveModuleCommodity">确定</el-button>
            </div>
          </el-dialog>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import Editor from "base/Editor";
import { isImage, isImgSizeLt2M } from "common/js/util";
import DBMall from "models/db/mall.js";
import DBCommodity from "models/db/commodity.js";
import ImgUploader from "models/img-upload.js";
const dbMall = new DBMall();
const dbCommodity = new DBCommodity();
const imgUploader = new ImgUploader();
let lodash = require("lodash");
// 页面模式
const pageModules = {
  addColumn: 1,
  updateColumn: 0
};
// 页面可添加的模块类型
const moduleTypeEnum = {
  bigModule: 1,
  smallModule: 2
};
// 模块信息类型
const moduleInfoTypeEnum = {
  picture: 1,
  generalGood: 2,
  promotionalGood: 3,
  richText: 4
};
// 模块信息为图片，图片类型
const moduleImgInfoTypes = {
  // 海报类型
  poster: 1,
  // 轮播图类型
  carousel: 2,
  // 横幅条类型
  banner: 3
};
// 字符串类型值的默认值
const STRING_EMPYT_VALUE = "";
// 大模块轮播图最多可添加数量
const BIG_MODULE_MAX_CAROUSEL = 6;
// 小模块轮播图最多可添加数量
const SMALL_MODULE_MAX_CAROUSEL = 3;
export default {
  data() {
    return {
      // 新增专栏 1，更新专栏 0
      pageModule: 1,
      // 显示编辑专栏信息页
      isEditingColumn: true,
      // 专栏信息
      columnInfo: {
        barName: "",
        barPath: "",
        status: 1,
        isTouristsVisible: 1,
      },
      // 新增栏目Form字段要求配置
      columnInfoRules: {
        barName: {
          required: true,
          message: "请输入栏目名称",
          trigger: "blur"
        },
        barPath: {
          required: true,
          message: "请输入栏目路径",
          trigger: "blur"
        }
      },
      // 新增专栏，保存后从服务器获取的专栏的id
      newColumnId: 0,
      // 编辑专栏，从当前页面URL中获取的被编辑专栏的id
      editedColumnId: 0,
      // 显示专栏模块编辑页
      isEditingModule: false,
      // 模块内容类型
      moduleInfoTypeEnum: moduleInfoTypeEnum,
      // 模块图片内容类型
      moduleImgInfoTypes: moduleImgInfoTypes,
      /**
       * 大模块相关
       */
      // 控制大模块的编辑框是否弹出
      isShowBigModuleEditBox: false,
      // 大模块内容类型--默认图片
      bigModuleInfoType: moduleInfoTypeEnum.picture,
      // 大模块内容为图片时，图片类型--默认海报图
      bigModuleInfoImgType: moduleImgInfoTypes.poster,
      // 大模块图片--海报Model
      bigModulePosterModel: {
        infoType: moduleInfoTypeEnum.picture,
        moduleInfo: {
          type: moduleImgInfoTypes.poster,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      },
      // 轮播图Model
      bigModuleCarouselModel: {
        infoType: moduleInfoTypeEnum.picture,
        moduleInfo: {
          type: moduleImgInfoTypes.carousel,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      },
      // 横图条Model
      bigModuleBannerModel: {
        infoType: moduleInfoTypeEnum.picture,
        moduleInfo: {
          type: moduleImgInfoTypes.banner,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      },
      // 商品Model
      bigModuleCommodityModel: {
        infoType: moduleInfoTypeEnum.generalGood,
        moduleInfo: {
          type: "table",
          data: []
        }
      },
      richTextContent: "", // 传入富文本编辑器的值
      // 富文本Model
      bigModuleRichtextModel: {
        infoType: moduleInfoTypeEnum.richText,
        moduleInfo: {
          type: "richtext",
          data: ""
        }
      },
      /**
       * 小模块相关
       */
      // 控制小模块的编辑框是否弹出
      isShowSmallModuleEditBox: false,
      // 小模块内容类型--默认图片
      smallModuleInfoType: moduleInfoTypeEnum.picture,
      // 小模块图片类型--默认海报图
      smallModuleImgInfoType: moduleImgInfoTypes.poster,
      // 小模块图片类型为海报图的话，可选图片张数--默认为 1
      smallModuleImgNum: 1,
      // 海报Model
      smallModulePosterModel: {
        infoType: moduleInfoTypeEnum.picture,
        moduleInfo: {
          type: moduleImgInfoTypes.poster,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      },
      // 轮播图Model
      smallModuleCarouselModel: {
        infoType: moduleInfoTypeEnum.picture,
        moduleInfo: {
          type: moduleImgInfoTypes.carousel,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      },
      // 商品Model
      smallModuleCommodityModel: {
        infoType: moduleInfoTypeEnum.generalGood,
        moduleInfo: {
          type: "table",
          data: []
        }
      },
      /**
       * moduleList--记录页面已有模块所对应的数据
       * 默认结构
       * {
       *   // 是否被编辑过
       *   hasEdited: false,
       *   // 模块类型
       *   type: moduleTypeEnum.bidModule
       *   // 模块详情
       *   data: null,
       * }
       */
      moduleList: [],
      /**
       * 选择商品弹框相关
       */
      // 模块--选择商品的弹框是否展示
      isShowGoodModal: false,
      // 商品数据列表--从服务器获取
      goodsList: [],
      // 商品数据总数
      totalCountOfGoods: 0,
      currentPageOfGoods: 1,
      // 商品列表相关--搜索关键字
      goodsQuery: "",
      // 商品列表相关---选择的商品分类
      selectedGoodsType: [null, null, null],
      // 初始化搜索
      isIntiSearch: true,
      // 商品具体搜索条件
      searchGoodOptions: {
        currentPage: 1,
        goodsName: "",
        category1Id: ""
      },
      // 商品列表相关---商品分类列表
      goodsTypeList: [],
      // 商品列表相关---商品分类props
      goodsTypeListProps: {
        value: "id",
        label: "cateName"
      },
      // 记录大模块商品编辑时勾选的商品
      bigModuleSelectedCommodity: [],
      // 记录小模块商品编辑时勾选的商品
      smallModuleSelectedCommodity: [],
      // 模块编辑时，选择商品模式，被选中将要添加的商品列表
      moduleTmpCommodityList: [],
      /**
       * 模块编辑相关
       */
      // 记录被当前被点击的模块在页面模块列表数组中的下标
      currentModuleIndex: 0,
      // 记录被点击模块携带的将被编辑的数据，之前是否已经编辑过
      currentModuleInfoHasEdited: false,
      // 记录被点击的大模块类型是什么，image 还是 commodity
      currentBigModuleInfoType: STRING_EMPYT_VALUE,
      // 记录被点击的大模块数据类型为图片的话，添加图片类型是什么
      currentBigModuleInfoImgType: 0,
      // 记录被点击的小模块类型是什么，image 还是 commodity
      currentSmallModuleType: STRING_EMPYT_VALUE,
      // 记录被点击的小模块数据类型为图片的话，添加图片类型是什么
      currentSmallModuleImgType: 0,
      // 记录被点击的小模块里哪个编辑按钮被选择了，共有三个 one two three
      currSmallModuleEditBtnIndex: 0,
      // 编辑栏目时从服务器加载的模块个数
      moduleNumOfEditedColumn: 0,
    };
  },
  computed: {
    bigModuleCarouselNumLsMax() {
      return (
        this.bigModuleCarouselModel.moduleInfo.data.length <
        BIG_MODULE_MAX_CAROUSEL
      );
    },
    smallModuleCarouselNumLsMax() {
      return (
        this.smallModuleCarouselModel.moduleInfo.data.length <
        SMALL_MODULE_MAX_CAROUSEL
      );
    },
    goodsTableNumDesc() {
      return this.isShowBigModuleEditBox &&
        this.bigModuleInfoType === moduleInfoTypeEnum.promotionalGood
        ? "促销数量"
        : "可售库存";
    }
  },
  watch: {
    isShowGoodModal: {
      handler(newVal) {
        if (newVal) {
          this.goodsList.map(item => {
            item.isSelected = false;
          });
          this.goodsQuery = "";
          this.selectedGoodsType = [null, null, null];
          // 重新获取数据
          this.filterCommodity();
        } else {
          this.goodsList = [];
        }
      }
    },
    goodsList: {
      deep: true,
      handler(newGoodsList) {
        this.$nextTick(() => {
          // 如果被选中，要将商品放入moduleTmpCommodityList，反之要剔除
          newGoodsList.map(item => {
            // 先判断item在不在this.moduleTmpCommodityList列表
            let isHave = this.moduleTmpCommodityList.find(
              editedCommodity => editedCommodity.commodityId === item.commodityId
            );
            if (item.isSelected) {
              // 选中
              if (!isHave) {
                this.moduleTmpCommodityList.push(item);
              }
            } else {
              if (isHave) {
                // 剔除
                let index = this.moduleTmpCommodityList.findIndex(
                  editedCommodity => editedCommodity.skuId === item.skuId
                );
                this.moduleTmpCommodityList.splice(index, 1);
              }
            }
          });
          console.log("此时将要添加的商品--", this.moduleTmpCommodityList);
        })
      }
    }
  },
  methods: {
    // 利用Sortable.js实现行拖拽
    rowDrop() {
      const tbody = document.querySelector(".modules");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({oldIndex, newIndex}) {
          const currRow = _this.moduleList.splice(oldIndex-4, 1)[0];
          _this.moduleList.splice(newIndex-4, 0, currRow);
          let data = [];
          _this.moduleList.map((value, index) => {
            let obj = {};
            obj.id = value.moduleId;
            obj.orderNum = index;
            data.push(obj);
          });
          dbMall.postDBUpdateSort(data).then(res => {
            if (!res.success) {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    //最多输入12个字节
    getCharLength(barName) {
      var iLength = 0; //记录字符的字节数
      for (var i = 0; i < barName.length; i++) {
        //遍历字符串中的每个字符
        if (barName.charCodeAt(i) > 255) {
          //如果当前字符的编码大于255
          iLength += 2; //所占字节数加2
        } else {
          iLength += 1; //否则所占字节数加1
        }
        if (iLength > 12) {
          this.columnInfo.barName = barName.slice(0, i);
          return;
        }
      }
    },
    // 富文本返回数据
    catchData(value) {
      console.log("富文本数据", value);
      this.richTextContent = value; // 在这里接受子组件传过来的参数，赋值给data里的参数
    },
    // 筛选商品
    filterCommodity() {
      this.searchGoodOptions.currentPage = 1;
      this.searchGoodOptions.goodsName = this.goodsQuery;
      this.searchGoodOptions.category1Id = this.selectedGoodsType[2]
        ? this.selectedGoodsType[2]
        : this.selectedGoodsType[1]
        ? this.selectedGoodsType[1]
        : this.selectedGoodsType[0];
      this._getGoodsList();
    },
    // 返回至mallTopBarList页面
    cancelColumnInfo() {
      this.$router.push({
        path: "/admin/mall/mall-top/mall-top-list"
      });
    },
    // 保存新栏目
    saveColumnInfo() {
      this.$refs.columnInfo.validate(valid => {
        if (valid) {
          if (this.pageModule === pageModules.updateColumn) {
            // 修改已有的栏目信息
            let data = {
              id: this.editedColumnId,
              name: this.columnInfo.barName,
              path: this.columnInfo.barPath,
              status: this.columnInfo.status,
              inVisitor: this.columnInfo.isTouristsVisible,
            };
            let reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/;
            let stop = reg.test(this.columnInfo.barPath);
            if (stop) {
              this._updateColumn(data);
            } else {
              this.$message.error("请输入英文、中文或数字");
            }
            // this._updateColumn(data);
          } else if (this.pageModule === pageModules.addColumn) {
            // 新增栏目信息
            let data = {
              name: this.columnInfo.barName,
              path: this.columnInfo.barPath,
              status: this.columnInfo.status,
              inVisitor: this.columnInfo.isTouristsVisible,
            };
            let reg = /^[\u4E00-\u9FA5A-Za-z0-9]+$/;
            let stop = reg.test(this.columnInfo.barPath);
            console.log(stop);
            if (stop) {
              this._addColumn(data);
            } else {
              this.$message.error("请输入英文、中文或数字");
            }
            // 展示模块编辑页面
            // this.isEditingColumn = false;
            // this.isEditingModule = true;
          }
          this.cancelColumnInfo()
          // 通过校验
        } else {
          // 未通过校验
          return false;
        }
      });
    },
    // 监听分页器变化
    handleQueryChange(query) {
      this.goodsList.map(item => {
        if (item.isSelected) {
          this.moduleTmpCommodityList.push(item);
        }
      });
      this.searchGoodOptions.currentPage = query.currentPage;
      this._getGoodsList();
    },
    // 监听小模块海报图个数选择
    onSmallModuleImgNumChange(label) {
      this._resetSmallModuleEditPosterModel();
    },
    addBigModule() {
      // 页面添加新的大模块节点
      let bigModule = this.$refs.bigModule.cloneNode(true);
      let target = this.$refs.modules;
      target.appendChild(bigModule);
      // isEditingColumnId 默认为0
      if (!this.pageModule) {
        // 更新专栏
        if (this.moduleList.length >= this.moduleNumOfEditedColumn) {
          // 如果当前页面的模块列表数据个数，大于等于从服务器加载的模块列表个数
          // 说明从服务器读取的数据渲染完毕
          // 再次点击添加大模块按钮的时候需要填充新数据来更新moduleList
          this.moduleList.push({
            hasEdited: false,
            type: moduleTypeEnum.bigModule,
            data: null
          });
        }
      } else {
        // 新增专栏
        this.moduleList.push({
          hasEdited: false,
          type: moduleTypeEnum.bigModule,
          data: null
        });
      }
      // cloneNode(true)无法复制通过 addEventListener和js动态绑定的事件
      // 所以节点复制后需要重新添加监听函数
      bigModule.onclick = e => {
        if (this.isShowBigModuleEditBox || this.isShowSmallModuleEditBox) {
          this.$alert("您有尚未保存的模块，请先完成该模块的编辑", "操作提示", {
            confirmButtonText: "确定",
            type: "warning",
            center: true
          });
          return false;
        }
        const deleteBntClassName = "big-module-delete-btn";
        // 被点击的HTML元素
        let clickedEle = e.target;
        // 对应的模块元素
        let moduleEle = e.currentTarget;
        // 记录可能被删除的模块元素
        this.willRemoveModuleEle = e.currentTarget;
        // 获取被点击的模块在当前页面所有模块列表里的下标
        let clickedModuleIndex = this._getClickedModuleIndex(moduleEle);
        // 记录被点击的模块的下标
        this.currentModuleIndex = clickedModuleIndex;
        // 先判断是否是删除按钮
        if (clickedEle.classList.contains(deleteBntClassName)) {
          // 点击的是删除模块按钮
          this.$confirm("即将删除此模块，所做修改可能丢失", "操作提示", {
            confirmButtonText: "删除模块",
            cancelButtonText: "保留模块",
            type: "warning"
          })
            .then(() => {
              // 点击删除模块
              let willDeleteData = this.moduleList[clickedModuleIndex];
              let moduleId = willDeleteData.moduleId
                ? willDeleteData.moduleId
                : 0;
              if (moduleId) {
                // 服务器更新
                if (!this.pageModule) {
                  // 更新专栏
                  this._deleteModuleInColumn(moduleId, this.editedColumnId);
                } else {
                  // 新增专栏
                  this._deleteModuleInColumn(moduleId, this.newColumnId);
                }
              } else {
                // 本地更新
                this.moduleList.splice(this.currentModuleIndex, 1);
                // 更新数据后还要删除该DOM节点
                this.$refs.modules.removeChild(this.willRemoveModuleEle);
                // 隐藏编辑框
                this._hideBigModuleEditBox();
                this._successDeleteModuleForColumnTip();
              }
            })
            .catch(action => {
              if (action === "cancel") {
                // 点击保留模块
                return false;
              }
            });
        } else {
          // 编辑按钮
          // 如果当前页面有其他编辑框处于编辑状态，提示用户先完成已打开的模块编辑任务
          // 如果用户点击删除，那么直接删除
          // 设置编辑框弹出位置
          this._setEditBoxPosition(
            e.target,
            this.$refs.modules,
            this.$refs.bigModuleEditBox
          );
          // 这里是点击模块进行编辑
          // 先判断编辑框弹出状态
          if (!this.isShowBigModuleEditBox) {
            // 展示编辑框
            this._showBigModuleEditBox();
          } else {
            // 隐藏编辑框
            this._hideBigModuleEditBox();
          }
          // 根据下标从moduleList中取出数据--注意对象引用的问题
          console.log("此时被点击的moduleId", clickedModuleIndex);
          let currentModuleData;
          try {
            currentModuleData = this.moduleList[clickedModuleIndex]
              ? JSON.parse(JSON.stringify(this.moduleList[clickedModuleIndex]))
              : {};
          } catch (error) {
            console.log("此时模块列表", this.moduleList);
            console.log(error);
            // debugger;
          }
          // 记录取出来的数据是修改保存过，还是未曾修改保存过即第一次编辑
          this.currentModuleInfoHasEdited = currentModuleData.hasEdited;
          if (currentModuleData.hasEdited) {
            // 被编辑过
            let currentData = currentModuleData.data;
            // 模块内容类型
            this.bigModuleInfoType = currentData.infoType;
            // 记录下当前模块的内容类型
            this.currentBigModuleInfoType = currentData.infoType;
            // 这里要分类处理图片模式和商品模式
            if (this.bigModuleInfoType === moduleInfoTypeEnum.picture) {
              // 模块内容类型为图片
              this.bigModuleInfoImgType = currentData.moduleInfo.type;
              // 记录下当前图片模块的图片类型
              this.currentBigModuleInfoImgType = currentData.moduleInfo.type;
              switch (this.bigModuleInfoImgType) {
                case moduleImgInfoTypes.poster:
                  this.bigModulePosterModel = currentData;
                  break;
                case moduleImgInfoTypes.carousel:
                  this.bigModuleCarouselModel = currentData;
                  break;
                case moduleImgInfoTypes.banner:
                  this.bigModuleBannerModel = currentData;
                  break;
                default:
                  break;
              }
            } else if (
              this.bigModuleInfoType === moduleInfoTypeEnum.generalGood
            ) {
              // 如果是商品编辑模式
              console.log("普通商品编辑模式--", currentData);
              this.bigModuleCommodityModel = currentData;
            } else if (
              this.bigModuleInfoType === moduleInfoTypeEnum.promotionalGood
            ) {
              console.log("促销商品编辑模式--", currentData);
              this.bigModuleCommodityModel = currentData;
            } else if (this.bigModuleInfoType === moduleInfoTypeEnum.richText) {
              // 富文本数据
              console.log("富文本编辑模式--", currentData);
              this.bigModuleRichtextModel = currentData;
            }
          } else {
            // 重置数据
            this._resetBigModuleModel();
          }
        }
      };
    },
    addSmallModule() {
      // 页面添加新的小模块节点
      let smallModule = this.$refs.smallModule.cloneNode(true);
      let target = this.$refs.modules;
      target.appendChild(smallModule);
      if (!this.pageModule) {
        // 更新栏目
        if (this.moduleList.length >= this.moduleNumOfEditedColumn) {
          // 如果当前页面的模块列表数据个数，大于等于从服务器加载的模块列表个数
          // 说明服务器拉取的数据渲染完毕，点击添加模块的时候需要填充新数据
          this.moduleList.push({
            hasEdited: false,
            type: moduleTypeEnum.smallModule,
            data: [null, null, null]
          });
        }
      } else {
        // 新增栏目
        this.moduleList.push({
          hasEdited: false,
          type: moduleTypeEnum.smallModule,
          data: [null, null, null]
        });
      }
      smallModule.onclick = e => {
        // 编辑操作
        if (this.isShowBigModuleEditBox || this.isShowSmallModuleEditBox) {
          this.$alert("您有尚未保存的模块，请先完成该模块的编辑", "操作提示", {
            confirmButtonText: "确定",
            type: "warning",
            center: true
          });
          return false;
        }
        // editEleClassName 和 deleteEleClassName 用来判断用户点击是编辑还是删除
        const editBtnClassName = "small-module-child";
        const deleteBtnClassName = "small-module-delete-btn";
        // No$EditEleClassName 用来区分点了哪个小编辑模块
        const No1EditBtnClassName = "one";
        const No2EditBtnClassName = "two";
        const No3EditBtnClassName = "three";
        // 被点击的HTML元素
        let clickedEle = e.target;
        // 对应的模块元素
        let moduleEle = e.currentTarget;
        // 记录可能被删除的模块元素
        this.willRemoveModuleEle = e.currentTarget;
        // 获取被点击的模块在当前页面所有模块列表里的下标
        let clickedModuleIndex = this._getClickedModuleIndex(moduleEle);
        // 记录被点击的模块的下标
        this.currentModuleIndex = clickedModuleIndex;
        // 先设置编辑框的弹出位置
        this._setEditBoxPosition(
          e.currentTarget,
          this.$refs.modules,
          this.$refs.smallModuleEditBox
        );
        // 判断是编辑还是删除操作
        if (clickedEle.classList.contains(deleteBtnClassName)) {
          // 点击的是删除按钮
          this.$confirm("即将删除此模块，所做修改可能丢失", "操作提示", {
            confirmButtonText: "删除模块",
            cancelButtonText: "保留模块",
            type: "warning"
          })
            .then(() => {
              let willDeleteData = this.moduleList[clickedModuleIndex];
              let { moduleId } = willDeleteData;
              console.log("被删除的模块id--", moduleId);
              if (moduleId) {
                // 服务器删除
                this._deleteModuleInColumn(moduleId, this.editedColumnId);
              } else {
                // 本地删除
                // 更新moduleList
                this.moduleList.splice(clickedModuleIndex, 1);
                // 更新数据后还要删除该DOM节点
                this.$refs.modules.removeChild(this.willRemoveModuleEle);
                // 隐藏编辑框
                this._hideSmallModuleEditBox();
              }
            })
            .catch(action => {
              if (action === "cancel") {
                console.log("继续编辑，什么也不做");
              }
            });
        } else {
          // 模块出现预览数据以后
          let editBtnIsClick = false;
          let targetEle = e.target;
          let child;
          while (!editBtnIsClick && targetEle) {
            child = targetEle;
            editBtnIsClick = targetEle.classList.contains(editBtnClassName);
            targetEle = targetEle.parentNode;
          }
          // 设置编辑框弹出状态
          if (!this.isShowSmallModuleEditBox) {
            // 编辑框是隐藏的，就弹出
            this._showSmallModuleEditBox();
          } else {
            // 编辑是弹出的，就隐藏
            this._hideSmallModuleEditBox();
          }
          // 记录被点击的模块的下标
          this.currentModuleIndex = clickedModuleIndex;
          // 根据下标从moduleList中取出数据
          let currentModuleData;
          currentModuleData = JSON.parse(
            JSON.stringify(this.moduleList[clickedModuleIndex])
          );
          console.log("当前被修改的小模块数据域--", currentModuleData);
          // 记录取出来的数据是修改保存过，还是未曾修改保存过即第一次编辑
          this.currentModuleInfoHasEdited = currentModuleData.hasEdited;
          // 现在要根据No$EditEleClassName区分点了哪个小模块
          if (child.classList.contains(No1EditBtnClassName)) {
            this.currSmallModuleEditBtnIndex = 0;
          } else if (child.classList.contains(No2EditBtnClassName)) {
            this.currSmallModuleEditBtnIndex = 1;
          } else if (child.classList.contains(No3EditBtnClassName)) {
            this.currSmallModuleEditBtnIndex = 2;
          }
          if (this.currentModuleInfoHasEdited) {
            // data如果不为undefined 说明已经被编辑过
            // 注意这里取出的data是个数组
            let currData = currentModuleData.data;
            currData = currData[this.currSmallModuleEditBtnIndex];
            // 取出需要填充到编辑框的数据
            // 注意，这里currData如果null，说明这个数据未被编辑过，需要给默认值
            currData = currData || {
              infoType: moduleInfoTypeEnum.picture,
              moduleInfo: {
                type: moduleImgInfoTypes.poster,
                data: [
                  {
                    imgSrc: STRING_EMPYT_VALUE,
                    linkSrc: STRING_EMPYT_VALUE,
                    editImg: true
                  }
                ]
              }
            };
            console.log("重新赋值的", currData);
            this.smallModuleInfoType = currData.infoType;
            // 记录下被点击的小模块类型是什么
            this.currentSmallModuleType = currData.infoType;
            // 这里要分类处理图片模式和商品模式
            if (this.smallModuleInfoType === moduleInfoTypeEnum.picture) {
              // 如果是图片编辑模式
              // 根据添加的图片模式来处理数据
              this.smallModuleImgInfoType = currData.moduleInfo.type;
              // 记录下添加的图片类型值
              this.currentSmallModuleImgType = currData.moduleInfo.type;
              switch (this.smallModuleImgInfoType) {
                case moduleImgInfoTypes.poster:
                  this.smallModuleImgNum = currData.moduleInfo.data.length;
                  this.smallModulePosterModel = currData;
                  break;
                case moduleImgInfoTypes.carousel:
                  this.smallModuleCarouselModel = currData;
                  break;
                default:
                  break;
              }
            } else if (
              this.smallModuleInfoType === moduleInfoTypeEnum.generalGood
            ) {
              // 如果是商品编辑模式
              console.log("当前编辑框的数据--", currData);
              this.smallModuleCommodityModel = currData;
            }
          } else {
            // 重置数据
            console.log("新数据");
            this._resetSmallModuleModel();
          }
        }
      };
    },
    addBigModuleCarouselImg() {
      // 大模块--新增轮播图
      if (this.bigModuleCarouselNumLsMax) {
        this.bigModuleCarouselModel.moduleInfo.data.push({
          imgSrc: STRING_EMPYT_VALUE,
          linkSrc: STRING_EMPYT_VALUE,
          editImg: true
        });
      } else {
        this.$alert(`最多添加${BIG_MODULE_MAX_CAROUSEL}张轮播图`, "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
    },
    deleteBigModuleCarouselImg(index) {
      this.bigModuleCarouselModel.moduleInfo.data.splice(index, 1);
    },
    addSmallModuleCarouselImg() {
      // 小模块模块--新增轮播图
      if (this.smallModuleCarouselNumLsMax) {
        this.smallModuleCarouselModel.moduleInfo.data.push({
          imgSrc: STRING_EMPYT_VALUE,
          linkSrc: STRING_EMPYT_VALUE,
          editImg: true
        });
      } else {
        this.$alert(
          `最多添加${SMALL_MODULE_MAX_CAROUSEL}张轮播图`,
          "操作提示",
          {
            confirmButtonText: "确定"
          }
        );
        return false;
      }
    },
    deleteSmallModuleCarouselImg(index) {
      this.smallModuleCarouselModel.moduleInfo.data.splice(index, 1);
    },
    // bigModule表格操作删除商品
    deleteBigModuleCommodity(props) {
      let index = props.$index;
      // 删除大模块里的数据
      this.bigModuleCommodityModel.moduleInfo.data.splice(index, 1);
    },
    // smallModule表格操作删除商品
    deleteSmallModuleCommodity(props) {
      let index = props.$index;
      this.smallModuleCommodityModel.moduleInfo.data.splice(index, 1);
    },
    // 模块--取消选中商品
    removeModuleCommodity() {
      this._resetCommodityToUnselected();
      this._hideAddCommodityDialog();
    },
    // 模块--确定选中的商品
    saveModuleCommodity() {
      // 判断当前编辑的是大模块还是小模块
      console.log("当前数据--", this.moduleList[this.currentModuleIndex]);
      // 点击确定的时候，必须有商品被选择，否则要提示
      if (!this.moduleTmpCommodityList.length) {
        this.$message({
          message: "请选择商品",
          center: true,
          type: "error",
          duration: 1000
        });
        return false;
      }
      let currModuleData = this.moduleList[this.currentModuleIndex];
      let { type } = currModuleData;
      // 是否存在重复选择商品
      let isRepeat = false;
      // 已选择的商品列表
      let selectedCommodityList;
      if (type === moduleTypeEnum.bigModule) {
        // 大模块
        selectedCommodityList = JSON.parse(
          JSON.stringify(this.bigModuleCommodityModel.moduleInfo.data)
        );
        selectedCommodityList.map(oldCommodity => {
          let id = oldCommodity.commodityId;
          let repeatedEle = this.moduleTmpCommodityList.find(
            newCommodity => newCommodity.commodityId === id
          );
          if (repeatedEle) {
            // 说明有重复
            isRepeat = true;
          }
        });
        if (isRepeat) {
          this.$alert(`您重复添加了商品，请重新选择`, "操作提示", {
            confirmButtonText: "确定",
            type: "warning",
            center: true
          });
          return false;
        }
        // 商品数量选择是否超出
        let lastSelectedCommodityNum = selectedCommodityList.length;
        let currSelectedCommodityNum = this.moduleTmpCommodityList.length;
        let total = lastSelectedCommodityNum + currSelectedCommodityNum;
        // 区分 普通商品 和 促销商品
        switch (this.bigModuleInfoType) {
          case moduleInfoTypeEnum.generalGood:
            if (total <= 5) {
              // 还未满5个或者刚好5个
              this.moduleTmpCommodityList.map(commodity => {
                selectedCommodityList.push(commodity);
              });
            } else {
              // 已经有5个了
              this.$alert(
                `最多添加5个商品，您已选择${total}个商品`,
                "操作提示",
                {
                  confirmButtonText: "确定",
                  type: "warning",
                  center: true
                }
              );
              return false;
            }
            break;
          case moduleInfoTypeEnum.promotionalGood:
            if (total <= 20) {
              // 还未满20个或者刚好20个
              this.moduleTmpCommodityList.map(commodity => {
                selectedCommodityList.push(commodity);
              });
            } else {
              // 已经有20个了
              this.$alert(
                `最多添加20个促销商品，您已选择${total}个商品`,
                "操作提示",
                {
                  confirmButtonText: "确定",
                  type: "warning",
                  center: true
                }
              );
              return false;
            }
            break;
          default:
            break;
        }
        this.bigModuleCommodityModel.moduleInfo.data = selectedCommodityList;
      } else if (type === moduleTypeEnum.smallModule) {
        // 小模块
        currModuleData = currModuleData.data[this.currSmallModuleEditBtnIndex];
        console.log("小模块第几个数据", currModuleData);
        if (currModuleData) {
          selectedCommodityList = JSON.parse(
            JSON.stringify(this.smallModuleCommodityModel.moduleInfo.data)
          );
        } else {
          selectedCommodityList = [];
        }
        selectedCommodityList.map(oldCommodity => {
          let id = oldCommodity.commodityId;
          let repeatedEle = this.moduleTmpCommodityList.find(
            newCommodity => newCommodity.commodityId === id
          );
          if (repeatedEle) {
            // 说明有重复
            isRepeat = true;
          }
        });
        if (isRepeat) {
          this.$alert(`您重复添加了商品，请重新选择`, "操作提示", {
            confirmButtonText: "确定",
            type: "warning",
            center: true
          });
          return false;
        }
        // 上一次的
        let lastSelectedCommodityNum = selectedCommodityList.length;
        let currSelectedCommodityNum = this.moduleTmpCommodityList.length;
        let total = lastSelectedCommodityNum + currSelectedCommodityNum;
        if (total <= 4) {
          // 还未满4个或者刚好4个
          this.moduleTmpCommodityList.map(commodity => {
            selectedCommodityList.push(commodity);
          });
        } else {
          // 已经有5个了
          this.$alert(`最多添加4个商品，您已选择${total}个商品`, "操作提示", {
            confirmButtonText: "确定",
            type: "warning",
            center: true
          });
          return false;
        }
        this.smallModuleCommodityModel.moduleInfo.data = selectedCommodityList;
      }
      // 然后将所选商品重置为未选中状态
      this._resetCommodityToUnselected();
      // 隐藏商品选择框
      this._hideAddCommodityDialog();
    },
    // 将所有商品重置为未选中状态
    _resetCommodityToUnselected() {
      this.moduleTmpCommodityList = []
      this.goodsList.map(item => {
        item.isSelected = false;
      });
    },
    // 显示商品选择框
    _showAddCommodityDialog() {
      this.isShowGoodModal = true;
    },
    // 隐藏商品选择框
    _hideAddCommodityDialog() {
      this.isShowGoodModal = false;
    },
    // 放弃大模块的编辑操作
    cancelBigModuleEdit() {
      this.$confirm("即将离开当前编辑模块，所做修改可能丢失", "操作提示", {
        confirmButtonText: "继续编辑",
        cancelButtonText: "放弃编辑",
        type: "warning"
      })
        .then(() => {
          console.log("继续编辑，什么也不做");
        })
        .catch(action => {
          console.log("放弃编辑");
          if (action === "cancel") {
            this._hideBigModuleEditBox();
          }
        });
    },
    // 保存大模块的编辑操作
    saveBigModuleEdit() {
      setTimeout(() => {
        // 从currentModuleIndex判断是哪个模块被点击了
        // 取出要修改的模块数据
        let willBeSaveData = this.moduleList[this.currentModuleIndex];
        console.log(willBeSaveData);
        let oldMoudleId = willBeSaveData.moduleId ? willBeSaveData.moduleId : 0;
        console.log("当前模块内容类型", this.bigModuleInfoType);
        // 先判断是图片还是商品
        if (this.bigModuleInfoType === moduleInfoTypeEnum.picture) {
          // 图片再判断是 海报？轮播？横幅
          switch (this.bigModuleInfoImgType) {
            case moduleImgInfoTypes.poster:
              if (this._bigModulePosterModelIsEmpty()) {
                this._invalidModuleInfoTip();
                return false;
              }
              // 根据currentModuleIndex在moduleList对应的位置填充数据
              if (oldMoudleId) {
                this._updateModuleListData(this.currentModuleIndex, {
                  hasEdited: true,
                  type: moduleTypeEnum.bigModule,
                  moduleId: oldMoudleId,
                  data: lodash.cloneDeep(this.bigModulePosterModel)
                });
              } else {
                this._updateModuleListData(this.currentModuleIndex, {
                  hasEdited: true,
                  type: moduleTypeEnum.bigModule,
                  data: lodash.cloneDeep(this.bigModulePosterModel)
                });
              }
              break;
            case moduleImgInfoTypes.carousel:
              if (this._bigModuleCarouselModelIsEmpty()) {
                this._invalidModuleInfoTip();
                return false;
              }
              if (oldMoudleId) {
                this._updateModuleListData(this.currentModuleIndex, {
                  hasEdited: true,
                  type: moduleTypeEnum.bigModule,
                  moduleId: oldMoudleId,
                  // data: lodash.cloneDeep(this.bigModuleCarouselModel)
                  data: JSON.parse(JSON.stringify(this.bigModuleCarouselModel))
                });
              } else {
                this._updateModuleListData(this.currentModuleIndex, {
                  hasEdited: true,
                  type: moduleTypeEnum.bigModule,
                  // data: lodash.cloneDeep(this.bigModuleCarouselModel)
                  data: JSON.parse(JSON.stringify(this.bigModuleCarouselModel))
                });
              }
              break;
            case moduleImgInfoTypes.banner:
              if (this._bigModuleBannerModelIsEmpty()) {
                this._invalidModuleInfoTip();
                return false;
              }
              // 根据currentModuleIndex在moduleList对应的位置填充数据
              if (oldMoudleId) {
                this._updateModuleListData(this.currentModuleIndex, {
                  hasEdited: true,
                  type: moduleTypeEnum.bigModule,
                  moduleId: oldMoudleId,
                  data: lodash.cloneDeep(this.bigModuleBannerModel)
                });
              } else {
                this._updateModuleListData(this.currentModuleIndex, {
                  hasEdited: true,
                  type: moduleTypeEnum.bigModule,
                  data: lodash.cloneDeep(this.bigModuleBannerModel)
                });
              }
              break;
            default:
              break;
          }
        } else if (
          this.bigModuleInfoType === moduleInfoTypeEnum.generalGood ||
          this.bigModuleInfoType === moduleInfoTypeEnum.promotionalGood
        ) {
          // 如果是商品类型，那么也是同图片类型一样
          if (this._bigModuleCommodityModelIsEmpty()) {
            // this._invalidModuleInfoTip();
            // return false;
          }
          // 根据currentModuleIndex在moduleList对应的位置填充数据
          const data = JSON.parse(JSON.stringify(this.bigModuleCommodityModel));
          data.infoType = this.bigModuleInfoType;
          if (oldMoudleId) {
            this._updateModuleListData(this.currentModuleIndex, {
              hasEdited: true,
              type: moduleTypeEnum.bigModule,
              moduleId: oldMoudleId,
              data: data
            });
          } else {
            this._updateModuleListData(this.currentModuleIndex, {
              hasEdited: true,
              type: moduleTypeEnum.bigModule,
              data: data
            });
          }
        } else if (this.bigModuleInfoType === moduleInfoTypeEnum.richText) {
          // 富文本数据类型
          // 根据currentModuleIndex在moduleList对应的位置填充数据
          console.log("富文本", this.bigModuleRichtextModel.moduleInfo.data);
          this.bigModuleRichtextModel.moduleInfo.data = this.richTextContent;
          if (this._bigModuleRichTextIsEmpty()) {
            this._invalidModuleInfoTip();
            return false;
          }
          const data = JSON.parse(JSON.stringify(this.bigModuleRichtextModel));
          console.log(data);
          data.infoType = this.bigModuleInfoType;
          if (oldMoudleId) {
            this._updateModuleListData(this.currentModuleIndex, {
              hasEdited: true,
              type: moduleTypeEnum.bigModule,
              moduleId: oldMoudleId,
              data: data
            });
          } else {
            this._updateModuleListData(this.currentModuleIndex, {
              hasEdited: true,
              type: moduleTypeEnum.bigModule,
              data: data
            });
          }
        }
        // 处理完后此时模块数据
        let newOrUpdateData = this.moduleList[this.currentModuleIndex];
        // 首先判断是在编辑已有的栏目页面还是新增栏目页面进行编辑
        // editedColumnId默认为0
        if (this.editedColumnId) {
          // editedColumnId不为0说明在编辑已有的栏目
          // 提交模块数据到服务器
          if (!oldMoudleId) {
            // 新增数据至服务器
            let data = {
              moduleId: this.editedColumnId, // 栏目Id
              type: 1, // module类型
              details: JSON.stringify(newOrUpdateData), // module详情
              orderNum: this.currentModuleIndex // module排序
            };
            this._addModuleForColumn(data);
          } else {
            // 更新数据至服务器
            let data = {
              moduleId: this.editedColumnId, // 栏目Id
              id: newOrUpdateData.moduleId, // 模块Id
              type: 1, // module类型
              details: JSON.stringify(newOrUpdateData) // module详情
            };
            console.log("已有栏目的基础上，更新数据至服务器", data);
            this._updateModuleForColumn(data);
          }
        } else {
          // editedColumnId为0值，说明是在编辑新增栏目页面
          // 提交模块数据到服务器
          if (!oldMoudleId) {
            // 新增数据至服务器
            let data = {
              moduleId: this.newColumnId, // 栏目Id
              type: 1, // module类型
              details: JSON.stringify(newOrUpdateData), // module详情
              orderNum: this.currentModuleIndex // module排序
            };
            this._addModuleForColumn(data);
          } else {
            // 更新数据至服务器
            let data = {
              moduleId: this.newColumnId, // 栏目Id
              id: newOrUpdateData.moduleId, // 模块Id
              type: 1, // module类型
              details: JSON.stringify(newOrUpdateData) // module详情
            };
            this._updateModuleForColumn(data);
          }
        }
        // 给用户反馈，提示保存成功
        this.$message({
          message: "保存成功",
          center: true,
          type: "success",
          duration: 1000,
          onClose: () => {
            // 隐藏编辑框
            this._hideBigModuleEditBox();
            let moduleEleList = document.querySelectorAll(".module-tpl");
            // 加2是因为页面有两个隐藏的类名为module-tpl元素
            let targetModuleEle =
              moduleEleList[this.currentModuleIndex + 2].children[0];
            // 先把非预览下的按钮文字隐藏掉
            targetModuleEle.children[0].style.display = "none";
            // 六种预览模式
            let posterImgEle = targetModuleEle.children[1];
            let carouselImgEle = targetModuleEle.children[2];
            let bannerImgEle = targetModuleEle.children[3];
            let commodityUlEle = targetModuleEle.children[4];
            let promotionUlEle = targetModuleEle.children[5];
            let richTextEle = targetModuleEle.children[6];
            let goodsList, commodityNum;
            const preCommodityNum = 5;
            console.log("数据", newOrUpdateData);
            console.log("类型", newOrUpdateData.data.infoType);
            switch (newOrUpdateData.data.infoType) {
              case moduleInfoTypeEnum.picture:
                // 海报图+轮播图+横幅条预览--展示一张图
                const imgSrc = newOrUpdateData.data.moduleInfo.data[0].imgSrc;
                console.log("图片地址", imgSrc);
                switch (newOrUpdateData.data.moduleInfo.type) {
                  case moduleImgInfoTypes.poster:
                    posterImgEle = targetModuleEle.children[1];
                    // 设置预览的图片
                    posterImgEle.style.display = "block";
                    posterImgEle.src = imgSrc;
                    // 其他五种要隐藏
                    carouselImgEle.style.display = "none";
                    bannerImgEle.style.display = "none";
                    commodityUlEle.style.display = "none";
                    promotionUlEle.style.display = "none";
                    richTextEle.style.display = "none";
                    break;
                  case moduleImgInfoTypes.carousel:
                    // 轮播图
                    carouselImgEle = targetModuleEle.children[2];
                    // 设置预览的图片
                    carouselImgEle.style.display = "block";
                    carouselImgEle.src = imgSrc;
                    // 其他五种种要隐藏
                    posterImgEle.style.display = "none";
                    bannerImgEle.style.display = "none";
                    commodityUlEle.style.display = "none";
                    promotionUlEle.style.display = "none";
                    richTextEle.style.display = "none";
                    break;
                  case moduleImgInfoTypes.banner:
                    console.log("横幅条");
                    bannerImgEle = targetModuleEle.children[3];
                    // 设置预览的图片
                    bannerImgEle.style.display = "block";
                    bannerImgEle.src = imgSrc;
                    // 其他三种要隐藏
                    posterImgEle.style.display = "none";
                    carouselImgEle.style.display = "none";
                    commodityUlEle.style.display = "none";
                    promotionUlEle.style.display = "none";
                    richTextEle.style.display = "none";
                    break;
                  default:
                    break;
                }
                break;
              case moduleInfoTypeEnum.generalGood:
                // 普通商品
                commodityUlEle.style.display = "flex";
                posterImgEle.style.display = "none";
                carouselImgEle.style.display = "none";
                bannerImgEle.style.display = "none";
                promotionUlEle.style.display = "none";
                richTextEle.style.display = "none";
                goodsList = newOrUpdateData.data.moduleInfo.data;
                goodsList.map((item, index) => {
                  let commodityLiEle = commodityUlEle.children[index];
                  commodityLiEle.style.display = "block";
                  let commodityImgEle = commodityLiEle.children[0];
                  commodityImgEle.setAttribute("src", item.commodityImg);
                  let commodityNameEle = commodityLiEle.children[1];
                  commodityNameEle.textContent = item.commodityName.substring(
                    0,
                    5
                  );
                  let commodityPriceEle = commodityLiEle.children[2];
                  commodityPriceEle.textContent = item.retailPrice;
                });
                commodityNum = goodsList.length;
                if (commodityNum < preCommodityNum) {
                  // 说明没有选满5个商品，那么要隐藏几个li
                  for (let i = commodityNum; i < preCommodityNum; i++) {
                    let commodityLiEle = commodityUlEle.children[i];
                    commodityLiEle.style.display = "none";
                  }
                }
                break;
              case moduleInfoTypeEnum.promotionalGood:
                // 促销商品
                promotionUlEle.style.display = "flex";
                posterImgEle.style.display = "none";
                carouselImgEle.style.display = "none";
                bannerImgEle.style.display = "none";
                commodityUlEle.style.display = "none";
                richTextEle.style.display = "none";
                goodsList = newOrUpdateData.data.moduleInfo.data;
                let promotionGoodUlEle = promotionUlEle.children[1];
                // 商品列表
                goodsList.map((item, index) => {
                  let commodityLiEle = promotionGoodUlEle.children[index];
                  commodityLiEle.style.display = "flex";
                  let commodityImgEle = commodityLiEle.children[0];
                  commodityImgEle.setAttribute("src", item.commodityImg);
                  let commodityNameEle = commodityLiEle.children[1];
                  commodityNameEle.textContent = item.commodityName.substring(
                    0,
                    5
                  );
                });
                // 商品个数
                commodityNum = goodsList.length;
                if (commodityNum < preCommodityNum) {
                  // 说明没有选满5个商品，那么要隐藏几个li
                  for (let i = commodityNum; i < preCommodityNum; i++) {
                    let commodityLiEle = promotionGoodUlEle.children[i];
                    commodityLiEle.style.display = "none";
                  }
                }
                break;
              case moduleInfoTypeEnum.richText:
                // 富文本
                promotionUlEle.style.display = "none";
                posterImgEle.style.display = "none";
                carouselImgEle.style.display = "none";
                bannerImgEle.style.display = "none";
                commodityUlEle.style.display = "none";
                richTextEle.style.display = "block";
                richTextEle.innerHTML = newOrUpdateData.data.moduleInfo.data;
                break;
              default:
                break;
            }
          }
        });
      },200)
    },
    // 放弃小模块的编辑操作
    cancelSmallModuleEdit() {
      this.$confirm("即将离开当前编辑模块，所做修改可能丢失", "操作提示", {
        confirmButtonText: "继续编辑",
        cancelButtonText: "放弃编辑",
        type: "warning"
      })
        .then(() => {
          console.log("继续编辑，什么也不做");
        })
        .catch(action => {
          if (action === "cancel") {
            // 放弃编辑就隐藏编辑框
            this._hideSmallModuleEditBox();
          }
        });
    },
    // 保存小模块的编辑操作
    saveSmallModuleEdit() {
      // 从currentModuleIndex判断是哪个模块被点击了
      // 取出要修改的模块数据
      let willBeSaveData = this.moduleList[this.currentModuleIndex];
      // 先判断是否有moduleId，moduleId不为0表示是修改已经保存过的数据模块
      let oldMoudleId = willBeSaveData.moduleId ? willBeSaveData.moduleId : 0;
      // 取出当前被修改的模块的数据域
      let currentModuleData = this.moduleList[this.currentModuleIndex];
      // 因为是小模块，所以smallModuleDataList为需要更新的数据
      let smallModuleDataList = currentModuleData.data;
      // 先判断是图片还是商品
      if (this.smallModuleInfoType === moduleInfoTypeEnum.picture) {
        // invalidMoudleEditSaveFlag--无效保存操作
        switch (this.smallModuleImgInfoType) {
          // 图片再判断是 海报？轮播？横幅
          case moduleImgInfoTypes.poster:
            // 小模块编辑的是海报图类型
            if (this._smallModulePosterModelIsEmpty()) {
              // 什么都没填写时，提示用户不能保存空数据
              this._invalidModuleInfoTip();
              return false;
            }
            // 根据currSmallModuleEditBtnIndex更新smallModuleDataList
            smallModuleDataList.splice(
              this.currSmallModuleEditBtnIndex,
              1,
              this.smallModulePosterModel
            );
            // 根据currentModuleIndex在moduleList对应的位置填充数据
            if (oldMoudleId) {
              // 有moduleId更新页面模块数据时要加上moduleId这个参数
              this._updateModuleListData(this.currentModuleIndex, {
                hasEdited: true,
                type: moduleTypeEnum.smallModule,
                moduleId: oldMoudleId,
                data: smallModuleDataList
              });
            } else {
              // moduleId为 0 说明是新加的模块
              this._updateModuleListData(this.currentModuleIndex, {
                hasEdited: true,
                type: moduleTypeEnum.smallModule,
                data: smallModuleDataList
              });
            }
            break;
          case moduleImgInfoTypes.carousel:
            // 小模块编辑的是轮播图类型
            if (this._smallModuleCarouselModelIsEmpty()) {
              // 有空数据的时候，提示用户不能保存空数据
              this._invalidModuleInfoTip();
              return false;
            }
            this.smallModuleCarouselModel.moduleInfo.data.map(item => {
              item.editImg = false;
            });
            // 根据currSmallModuleEditBtnIndex更新smallModuleDataList
            smallModuleDataList.splice(
              this.currSmallModuleEditBtnIndex,
              1,
              this.smallModuleCarouselModel
            );
            // 根据currentModuleIndex在moduleList对应的位置填充数据
            if (oldMoudleId) {
              this._updateModuleListData(this.currentModuleIndex, {
                hasEdited: true,
                type: moduleTypeEnum.smallModule,
                moduleId: oldMoudleId,
                data: smallModuleDataList
              });
            } else {
              this._updateModuleListData(this.currentModuleIndex, {
                hasEdited: true,
                type: moduleTypeEnum.smallModule,
                data: smallModuleDataList
              });
            }
            break;
          default:
            break;
        }
      } else {
        // 如果是商品类型，那么也是同图片类型一样
        // 根据currSmallModuleEditBtnIndex更新smallModuleDataList
        if (this._smallModuleCommodityModelIsEmpty()) {
          // 什么商品都没选择时，提示用户不能保存空数据
          // console.log(0);
          // this._invalidModuleInfoTip();
          // return false;
        }
        smallModuleDataList.splice(
          this.currSmallModuleEditBtnIndex,
          1,
          this.smallModuleCommodityModel
        );
        // 根据currentModuleIndex在moduleList对应的位置填充数据
        if (oldMoudleId) {
          this._updateModuleListData(this.currentModuleIndex, {
            hasEdited: true,
            type: moduleTypeEnum.smallModule,
            moduleId: oldMoudleId,
            data: smallModuleDataList
          });
        } else {
          this._updateModuleListData(this.currentModuleIndex, {
            hasEdited: true,
            type: moduleTypeEnum.smallModule,
            data: smallModuleDataList
          });
        }
      }
      // 将更新的模块数据或新增的模块数据提交至服务器
      let newOrUpdateData = this.moduleList[this.currentModuleIndex];
      if (this.editedColumnId) {
        // editedColumnId不为0说明在编辑已有的栏目
        // 提交模块数据到服务器
        if (!oldMoudleId) {
          // 新增数据至服务器
          console.log("小模块新增");
          let data = {
            moduleId: this.editedColumnId, // 栏目Id
            type: 1, // 模块类型
            details: JSON.stringify(newOrUpdateData), // 模块详情
            orderNum: this.currentModuleIndex // 模块排序
          };
          console.log(data);
          this._addModuleForColumn(data);
        } else {
          // 更新数据至服务器
          console.log("小模块更新");
          let data = {
            moduleId: this.editedColumnId, // 栏目Id
            id: newOrUpdateData.moduleId, // 模块Id
            type: 1, // 模块类型
            details: JSON.stringify(newOrUpdateData) // 模块详情
          };
          console.log(data);
          this._updateModuleForColumn(data);
        }
      } else {
        // editedColumnId为0值，说明是在编辑新增栏目页面
        // 提交模块数据到服务器
        if (!oldMoudleId) {
          // 新增数据至服务器
          console.log("5");
          let data = {
            moduleId: this.newColumnId, // 栏目Id
            type: 1, // 模块类型
            details: JSON.stringify(newOrUpdateData), // 模块详情
            orderNum: this.currentModuleIndex // 模块排序
          };
          console.log(data);
          this._addModuleForColumn(data);
        } else {
          // 更新数据至服务器
          console.log("6");
          let data = {
            moduleId: this.newColumnId, // 栏目Id
            id: newOrUpdateData.moduleId, // 模块Id
            type: 1, // 模块类型
            details: JSON.stringify(newOrUpdateData) // 模块详情
          };
          console.log(data);
          this._updateModuleForColumn(data);
        }
      }
      console.log("此时小模块的数据域", this.smallModulePosterModel);
      // 给用户反馈，提示保存成功
      this.$message({
        message: "保存成功",
        center: true,
        type: "success",
        duration: 1000,
        onClose: () => {
          // 隐藏编辑框
          this._hideSmallModuleEditBox();
          console.log("新数据", newOrUpdateData);
          console.log("小模块图片数量", this.smallModuleImgNum);
          // 给小模块填充预览数据
          let moduleEleList = document.querySelectorAll(".module-tpl");
          // 加2是因为页面有两个隐藏的类名为module-tpl元素
          let targetModuleEleList = moduleEleList[this.currentModuleIndex + 2];
          // 被编辑的小模块 div.small-module-child
          let targetModuleEle =
            targetModuleEleList.children[this.currSmallModuleEditBtnIndex];
          // 先把非预览下的按钮文字隐藏掉
          targetModuleEle.children[0].style.display = "none";
          // 四种预览模式
          let posterImgEle = targetModuleEle.children[1];
          let postersContainerEle = targetModuleEle.children[2];
          let carouselImgEle = targetModuleEle.children[3];
          let commodityUlEle = targetModuleEle.children[4];
          // 被编辑的小模块数据
          const currSmallModuleData =
            newOrUpdateData.data[this.currSmallModuleEditBtnIndex];
          switch (currSmallModuleData.infoType) {
            case moduleInfoTypeEnum.picture:
              // 海报图+轮播图+横幅条预览--展示一张图
              switch (currSmallModuleData.moduleInfo.type) {
                case moduleImgInfoTypes.poster:
                  if (this.smallModuleImgNum === 1) {
                    // 一张海报图
                    let firstImgSrc =
                      currSmallModuleData.moduleInfo.data[0].imgSrc;
                    posterImgEle.style.display = "block";
                    posterImgEle.src = firstImgSrc;
                    // 其他三种隐藏
                    postersContainerEle.style.display = "none";
                    carouselImgEle.style.display = "none";
                    commodityUlEle.style.display = "none";
                  } else if (this.smallModuleImgNum === 2) {
                    // 两张海报图
                    postersContainerEle.style.display = "flex";
                    // 其他三种隐藏
                    posterImgEle.style.display = "none";
                    carouselImgEle.style.display = "none";
                    commodityUlEle.style.display = "none";
                    let firstImgSrc =
                      currSmallModuleData.moduleInfo.data[0].imgSrc;
                    let firstPosterImgEle = postersContainerEle.children[0];
                    firstPosterImgEle.src = firstImgSrc;
                    let secondPosterImgEle = postersContainerEle.children[1];
                    let secondImgSrc =
                      currSmallModuleData.moduleInfo.data[1].imgSrc;
                    secondPosterImgEle.src = secondImgSrc;
                  }
                  break;
                case moduleImgInfoTypes.carousel:
                  let imgSrc = currSmallModuleData.moduleInfo.data[0].imgSrc;
                  carouselImgEle.style.display = "block";
                  carouselImgEle.src = imgSrc;
                  // 其他三种隐藏
                  posterImgEle.style.display = "none";
                  postersContainerEle.style.display = "none";
                  commodityUlEle.style.display = "none";
                  break;
                default:
                  break;
              }
              break;
            case moduleInfoTypeEnum.generalGood:
              // 普通商品
              commodityUlEle.style.display = "flex";
              posterImgEle.style.display = "none";
              postersContainerEle.style.display = "none";
              carouselImgEle.style.display = "none";
              let goodsList = currSmallModuleData.moduleInfo.data;
              goodsList.map((item, index) => {
                let commodityLiEle = commodityUlEle.children[index];
                commodityLiEle.style.display = "flex";
                let commodityImgEle = commodityLiEle.children[0];
                commodityImgEle.setAttribute("src", item.commodityImg);
                let commodityNameEle = commodityLiEle.children[1];
                commodityNameEle.textContent = item.commodityName.substring(
                  0,
                  5
                );
              });
              // 商品个数
              let commodityNum = goodsList.length;
              const preCommodityNum = 4;
              if (commodityNum < preCommodityNum) {
                // 说明没有选满4个商品，那么要隐藏几个li
                for (let i = commodityNum; i < preCommodityNum; i++) {
                  let commodityLiEle = commodityUlEle.children[i];
                  commodityLiEle.style.display = "none";
                }
              }
              break;
            default:
              break;
          }
        }
      });
    },
    // 大模块点击添加商品
    bigModuleAddCommodity() {
      // 拉起弹框
      this.isShowGoodModal = true;
      if (!this.goodsList.length) {
        this._getCommodityDialogInfo();
      }
    },
    // 小模块点击添加商品
    smallModuleAddCommodity() {
      // 拉起弹框
      this.isShowGoodModal = true;
      if (!this.goodsList.length) {
        this._getCommodityDialogInfo();
      }
    },
    // 获取所有商品分类
    _getGoodsTypeList() {
      dbCommodity
        .getDBGoodsClassify()
        .then(res => {
          if (res.success) {
            console.log("商品分类--", res.result);
            this.goodsTypeList = res.result;
          } else {
            console.log("获取分类错误--", res.message);
          }
        })
        .catch(e => {
          console.log("获取分类异常--", e);
        });
    },
    // 获取商品列表
    _getGoodsList() {
      console.log("获取服务器商品列表", this.bigModuleInfoType);
      // 先判断当前是大编辑框还是小编辑框
      if (this.isShowBigModuleEditBox) {
        // 大编辑框
        console.log("大编辑框");
        console.log("添加内容类型--", this.bigModuleInfoType);
        switch (this.bigModuleInfoType) {
          case moduleInfoTypeEnum.generalGood:
            // 普通商品列表
            console.log("普通商品");
            dbCommodity
              // .getGeneralGoodsList(this.searchGoodOptions)
              .getAddMallGeneralGoodsList(this.searchGoodOptions)
              .then(res => {
                this._handleGoodsListRes(res);
              })
              .catch(e => {
                console.log("普通商品列表异常--", e);
              });
            break;
          case moduleInfoTypeEnum.promotionalGood:
            // 促销商品
            console.log("促销商品");
            dbCommodity
              .getAddMallPromotionalGoodsList(this.searchGoodOptions)
              .then(res => {
                this._handleGoodsListRes(res);
              })
              .catch(e => {
                console.log("促销商品列表异常--", e);
              });
            break;
          default:
            break;
        }
      } else if (this.isShowSmallModuleEditBox) {
        switch (this.smallModuleInfoType) {
          case moduleInfoTypeEnum.generalGood:
            // 普通商品列表
            console.log("普通商品");
            dbCommodity
              // .getGeneralGoodsList(this.searchGoodOptions)
              .getAddMallGeneralGoodsList(this.searchGoodOptions)
              .then(res => {
                this._handleGoodsListRes(res);
              })
              .catch(e => {
                console.log("普通商品列表异常--", e);
              });
            break;
          case moduleInfoTypeEnum.promotionalGood:
            // 促销商品
            console.log("促销商品");
            dbCommodity
              .getAddMallPromotionalGoodsList(this.searchGoodOptions)
              .then(res => {
                this._handleGoodsListRes(res);
              })
              .catch(e => {
                console.log("促销商品列表异常--", e);
              });
            break;
          default:
            break;
        }
      }
    },
    _handleGoodsListRes(res) {
      if (res.success) {
        console.log("商品列表数据--", res.result);
        let { currentPage, totalNum, items } = res.result;
        this.currentPageOfGoods = currentPage;
        this.totalCountOfGoods = totalNum;
        this.goodsList = [];
        items &&
          items.map(commodity => {
            let imgList = commodity.itemImages;
            this.goodsList.push({
              isSelected: false,
              commodityId: commodity.id,
              commodityImg: imgList[0],
              commodityName: commodity.goodsName,
              commodityClassify: commodity.categoryName || "",
              retailPrice: commodity.defaultPrice,
              ableInventory: commodity["totalSaleSum"]
            });
          });
      }
    },
    _isImage(fileType) {
      return (
        fileType === "image/jpeg" ||
        fileType === "image/jpg" ||
        fileType === "image/png"
      );
    },
    _isLt2M(fileSize) {
      return fileSize / 1024 / 1024 < 2;
    },
    // 大模块海报图文件变更
    bigModulePosterChange(file) {
      // 每次进来前清空
      this.bigModulePosterRaw = null;
      let isIMAGE = isImage(file.raw.type);
      if (!isIMAGE) {
        this.$alert("请选择图片文件", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      let isLt2M = isImgSizeLt2M(file.size);
      if (!isLt2M) {
        this.$alert("图片体积大于2M，请重新选择", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      this.bigModulePosterRaw = file.raw;
    },
    // 大模块海报图上传前
    beforeUploadBigModulePosterImg() {
      return !!this.bigModulePosterRaw;
    },
    // 大模块海报图上传
    uploadBigModulePosterImg() {
      // 开启上传遮罩层
      let loading = this.$loading({
        lock: true,
        text: "图片上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // 上传图片
      imgUploader
        .postImgUpload(this.bigModulePosterRaw)
        .then(res => {
          if (!res.errorCode) {
            this.bigModulePosterModel.moduleInfo.data[0].imgSrc = res.imgUrl;
            this.bigModulePosterModel.moduleInfo.data[0].editImg = false;
            this._successUploadedImgTip();
          } else {
            this._failUploadedImgTip();
          }
          loading.close();
        })
        .catch(e => {
          console.log("图片上传失败--", e);
          this._failUploadedImgTip();
          loading.close();
        });
    },
    // 大模块横幅条文件变更
    bigModuleBannerChange(file) {
      // 每次进来前清空
      this.bigModuleBannerRaw = null;
      let isIMAGE = isImage(file.raw.type);
      if (!isIMAGE) {
        this.$alert("请选择图片文件", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      let isLt2M = isImgSizeLt2M(file.size);
      if (!isLt2M) {
        this.$alert("图片体积大于2M，请重新选择", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      this.bigModuleBannerRaw = file.raw;
    },
    beforeUploadBigModuleBannerImg() {
      return !!this.bigModuleBannerRaw;
    },
    // 大模块横幅条上传
    uploadBigModuleBannerImg() {
      // 开启上传遮罩层
      let loading = this.$loading({
        lock: true,
        text: "图片上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // 上传图片
      imgUploader
        .postImgUpload(this.bigModuleBannerRaw)
        .then(res => {
          if (!res.errorCode) {
            console.log("图片上传后的url", res.imgUrl);
            this.bigModuleBannerModel.moduleInfo.data[0].imgSrc = res.imgUrl;
            this.bigModuleBannerModel.moduleInfo.data[0].editImg = false;
            this._successUploadedImgTip();
          } else {
            this._failUploadedImgTip();
          }
          loading.close();
        })
        .catch(e => {
          console.log("图片上传失败--", e);
          this._failUploadedImgTip();
          loading.close();
        });
    },
    // 判断哪一个轮播图上传组件被点击了
    onBigModuleCarouselClick(index) {
      this.currentonBigModuleCarouselIndex = index;
    },
    // 大模块轮播图文件变更
    bigModuleCarouselChange(file) {
      // 首先判断是哪个轮播图上传被点击了
      let index = this.currentonBigModuleCarouselIndex;
      this["bigModuleBannerRaw" + index] = null;
      let isIMAGE = isImage(file.raw.type);
      if (!isIMAGE) {
        this.$alert("请选择图片文件", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      let isLt2M = isImgSizeLt2M(file.size);
      if (!isLt2M) {
        this.$alert("图片体积大于2M，请重新选择", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      this["bigModuleBannerRaw" + index] = file.raw;
    },
    beforeUploadBigModuleCarouselImg() {
      let index = this.currentonBigModuleCarouselIndex;
      return !!this["bigModuleBannerRaw" + index];
    },
    // 大模块轮播图上传
    uploadBigModuleCarouselImg() {
      let i = this.currentonBigModuleCarouselIndex;
      // 开启上传遮罩层
      let loading = this.$loading({
        lock: true,
        text: "图片上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // 上传图片
      imgUploader
        .postImgUpload(this["bigModuleBannerRaw" + i])
        .then(res => {
          if (!res.errorCode) {
            this.bigModuleCarouselModel.moduleInfo.data[i].imgSrc = res.imgUrl;
            this.bigModuleCarouselModel.moduleInfo.data[i].editImg = false;
            this._successUploadedImgTip();
          } else {
            this._failUploadedImgTip();
          }
          loading.close();
        })
        .catch(e => {
          this._failUploadedImgTip();
          loading.close();
        });
    },
    // 哪个海报图被点击了
    onSmallModulePosterClick(index) {
      this.currSmallModulePosterIndex = index;
    },
    // 小模块海报图
    onSmallModulePosterImgChange(file) {
      // 首先判断是哪个海报图上传被点击了
      let i = this.currSmallModulePosterIndex;
      this["smallModulePosterRaw" + i] = null;
      let isIMAGE = isImage(file.raw.type);
      if (!isIMAGE) {
        this.$alert("请选择图片文件", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      let isLt2M = isImgSizeLt2M(file.size);
      if (!isLt2M) {
        this.$alert("图片体积大于2M，请重新选择", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      this["smallModulePosterRaw" + i] = file.raw;
    },
    beforeUploadSmallModulePosterImg() {
      let i = this.currSmallModulePosterIndex;
      return !!this["smallModulePosterRaw" + i];
    },
    uploadSmallModulePosterImg() {
      let i = this.currSmallModulePosterIndex;
      // 开启上传遮罩层
      let loading = this.$loading({
        lock: true,
        text: "图片上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // 上传图片
      imgUploader
        .postImgUpload(this["smallModulePosterRaw" + i])
        .then(res => {
          if (!res.errorCode) {
            console.log("图片数据", res);
            console.log(
              "模型数据",
              this.smallModulePosterModel.moduleInfo.data
            );
            this.smallModulePosterModel.moduleInfo.data[i].imgSrc = res.imgUrl;
            this.smallModulePosterModel.moduleInfo.data[i].editImg = false;
            this._successUploadedImgTip();
          } else {
            this._failUploadedImgTip();
          }
          loading.close();
        })
        .catch(e => {
          console.log("图片上传失败--", e);
          this._successUploadedImgTip();
          loading.close();
        });
    },
    // 小模块--判断哪一个轮播图上传组件被点击了
    onSmallModuleCarouselClick(index) {
      this.currSmallModuleCarouselIndex = index;
    },
    // 小模块轮播图文件变更
    smallModuleCarouselChange(file) {
      // 首先判断是哪个轮播图上传被点击了
      let i = this.currSmallModuleCarouselIndex;
      console.log("第几个", i);
      this["smallModuleCarouselRaw" + i] = null;
      let isIMAGE = isImage(file.raw.type);
      if (!isIMAGE) {
        this.$alert("请选择图片文件", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      let isLt2M = isImgSizeLt2M(file.size);
      if (!isLt2M) {
        this.$alert("图片体积大于2M，请重新选择", "操作提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      this["smallModuleCarouselRaw" + i] = file.raw;
      console.log("图片对象", this["smallModuleCarouselRaw" + i]);
    },
    beforeUploadSmallModuleCarouselImg() {
      let i = this.currSmallModuleCarouselIndex;
      console.log("上传之前", i, !!this["smallModuleCarouselRaw" + i]);
      return !!this["smallModuleCarouselRaw" + i];
    },
    // 小模块轮播图上传
    uploadSmallModuleCarouselImg() {
      console.log("开始");
      let i = this.currSmallModuleCarouselIndex;
      // 开启上传遮罩层
      let loading = this.$loading({
        lock: true,
        text: "图片上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // 上传图片
      imgUploader
        .postImgUpload(this["smallModuleCarouselRaw" + i])
        .then(res => {
          console.log("响应结果--", res);
          if (!res.errorCode) {
            this.smallModuleCarouselModel.moduleInfo.data[i].imgSrc =
              res.imgUrl;
            this.smallModuleCarouselModel.moduleInfo.data[i].editImg = false;
            this._successUploadedImgTip();
          } else {
            this._failUploadedImgTip();
          }
          loading.close();
        })
        .catch(e => {
          this._failUploadedImgTip();
          loading.close();
        });
    },
    // 跳转栏目编辑
    onEditBar() {
      this.isEditingColumn = true;
      this.isEditingModule = false;
    },
    // 跳转页面编辑
    onEditPage() {
      this.isEditingColumn = false;
      this.isEditingModule = true;
    },
    _successUploadedImgTip() {
      this.$message({
        message: "图片上传成功",
        center: true,
        type: "success",
        duration: 1000
      });
    },
    _failUploadedImgTip() {
      this.$message({
        message: "图片上传失败",
        center: true,
        type: "error",
        duration: 1000
      });
    },
    // 判断编辑框的数据域是为默认的空数据
    _bigModulePosterModelIsEmpty() {
      return !(
        this.bigModulePosterModel.moduleInfo.data[0].imgSrc ||
        this.bigModulePosterModel.moduleInfo.data[0].linkSrc
      );
    },
    _bigModuleCarouselModelIsEmpty() {
      return !(
        this.bigModuleCarouselModel.moduleInfo.data[0].imgSrc ||
        this.bigModuleCarouselModel.moduleInfo.data[0].linkSrc
      );
    },
    _bigModuleBannerModelIsEmpty() {
      return !(
        this.bigModuleBannerModel.moduleInfo.data[0].imgSrc ||
        this.bigModuleBannerModel.moduleInfo.data[0].linkSrc
      );
    },
    _bigModuleCommodityModelIsEmpty() {
      return !this.bigModuleCommodityModel.moduleInfo.data.length;
    },
    _bigModuleRichTextIsEmpty() {
      return this.bigModuleRichtextModel.moduleInfo.data === "<p><br></p>";
    },
    _smallModulePosterModelIsEmpty() {
      return this.smallModulePosterModel.moduleInfo.data.some(
        item => item.imgSrc === STRING_EMPYT_VALUE
      );
    },
    _smallModuleCarouselModelIsEmpty() {
      return this.smallModuleCarouselModel.moduleInfo.data.some(
        item => item.imgSrc === STRING_EMPYT_VALUE
      );
    },
    _smallModuleCommodityModelIsEmpty() {
      return !this.smallModuleCommodityModel.moduleInfo.data.length;
    },
    // 获取当前被点击的大模块在页面大模块列表中的下标
    _getClickedModuleIndex(clickedModule) {
      let moduleList = document.querySelectorAll(".module-tpl");
      // 返回值减2是因为页面默认有两个不显示的moduleTpl作为复制节点用的原节点
      return (
        Array.from(moduleList).findIndex(item => item === clickedModule) - 2
      );
    },
    // 重置bigModulePosterModel
    _resetBigModuleEditPosterModel() {
      this.bigModulePosterModel = {
        // 模块类型
        infoType: moduleInfoTypeEnum.picture,
        // 模块数据
        moduleInfo: {
          type: moduleImgInfoTypes.poster,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      };
    },
    // 重置smallModulePosterModel
    _resetSmallModuleEditPosterModel() {
      if (this.smallModuleImgNum === 1) {
        this.smallModulePosterModel = {
          infoType: moduleInfoTypeEnum.picture,
          moduleInfo: {
            type: moduleImgInfoTypes.poster,
            data: [
              {
                imgSrc: STRING_EMPYT_VALUE,
                linkSrc: STRING_EMPYT_VALUE,
                editImg: true
              }
            ]
          }
        };
      } else if (this.smallModuleImgNum === 2) {
        this.smallModulePosterModel = {
          infoType: moduleInfoTypeEnum.picture,
          moduleInfo: {
            type: moduleImgInfoTypes.poster,
            data: [
              {
                imgSrc: STRING_EMPYT_VALUE,
                linkSrc: STRING_EMPYT_VALUE,
                editImg: true
              },
              {
                imgSrc: STRING_EMPYT_VALUE,
                linkSrc: STRING_EMPYT_VALUE,
                editImg: true
              }
            ]
          }
        };
      }
    },
    // 重置bigModuleCarouselModel
    _resetBigModuleEditCarouselModel() {
      this.bigModuleCarouselModel = {
        infoType: moduleInfoTypeEnum.picture,
        moduleInfo: {
          type: moduleImgInfoTypes.carousel,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      };
    },
    // 重置smallModuleCarouselModel
    _resetSmallModuleEditCarouselModel() {
      this.smallModuleCarouselModel = {
        infoType: moduleInfoTypeEnum.picture,
        moduleInfo: {
          type: moduleImgInfoTypes.carousel,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      };
    },
    // 重置bigModuleEditBannerlModel
    _resetBigModuleEditBannerModel() {
      this.bigModuleBannerModel = {
        infoType: moduleInfoTypeEnum.picture,
        moduleInfo: {
          type: moduleImgInfoTypes.banner,
          data: [
            {
              imgSrc: STRING_EMPYT_VALUE,
              linkSrc: STRING_EMPYT_VALUE,
              editImg: true
            }
          ]
        }
      };
    },
    // 重置bigModuleCommodityModel
    _resetbigModuleCommodityModel() {
      this.bigModuleCommodityModel = {
        infoType: moduleInfoTypeEnum.generalGood,
        moduleInfo: {
          type: "table",
          data: []
        }
      };
    },
    // 重置bigModuleRichtextModel
    _resetBigModuleRichtextModel() {
      this.bigModuleRichtextModel = {
        infoType: moduleInfoTypeEnum.richText,
        moduleInfo: {
          type: "richtext",
          data: ""
        }
      };
    },
    // 重置smallModuleCommodityModel
    _resetsmallModuleCommodityModel() {
      this.smallModuleCommodityModel = {
        infoType: moduleInfoTypeEnum.generalGood,
        moduleInfo: {
          type: "table",
          data: []
        }
      };
    },
    // 第一次点击大模块编辑框，重置为大模块编辑框的默认数据
    _resetBigModuleModel() {
      this.currentModuleInfoHasEdited = false;
      this.bigModuleInfoType = moduleInfoTypeEnum.picture;
      this.bigModuleInfoImgType = moduleImgInfoTypes.poster;
      this._resetBigModuleEditPosterModel();
      this._resetBigModuleEditCarouselModel();
      this._resetBigModuleEditBannerModel();
      this._resetbigModuleCommodityModel();
      this._resetBigModuleRichtextModel();
    },
    // 第一次点击小模块编辑框，重置为小模块编辑框的默认数据
    _resetSmallModuleModel() {
      this.currentModuleInfoHasEdited = false;
      this.smallModuleInfoType = moduleInfoTypeEnum.picture;
      this.smallModuleImgInfoType = moduleImgInfoTypes.poster;
      this._resetSmallModuleEditPosterModel();
      this._resetSmallModuleEditCarouselModel();
      this._resetsmallModuleCommodityModel();
    },
    // 设置编辑框的弹出位置
    _setEditBoxPosition(clickedBox, containerBox, editBox) {
      const marginEditBoxWithContainerBox = 32;
      let clickedBoxRect = clickedBox.getBoundingClientRect();
      let clickedBoxTop =
        clickedBoxRect.top +
        (window.pageYOffset || document.documentElement.scrollTop) -
        (document.documentElement.clientTop || 0);
      let containerBoxRect = containerBox.getBoundingClientRect();
      let containerBoxTop =
        containerBoxRect.top +
        (window.pageYOffset || document.documentElement.scrollTop) -
        (document.documentElement.clientTop || 0);
      let diffY = clickedBoxTop - containerBoxTop;
      let diffX = containerBoxRect.width + marginEditBoxWithContainerBox;
      editBox.style.left = diffX + "px";
      editBox.style.top = diffY + "px";
    },
    // 展示大编辑框
    _showBigModuleEditBox() {
      this.isShowBigModuleEditBox = true;
    },
    // 隐藏大编辑框
    _hideBigModuleEditBox() {
      this.isShowBigModuleEditBox = false;
      this._resetBigModuleEditPosterModel();
      this._resetBigModuleEditCarouselModel();
      this._resetBigModuleEditBannerModel();
      this._resetbigModuleCommodityModel();
      this._resetBigModuleRichtextModel();
    },
    // 展示小编辑框
    _showSmallModuleEditBox() {
      this.isShowSmallModuleEditBox = true;
      this._resetSmallModuleEditPosterModel();
      this._resetSmallModuleEditCarouselModel();
      this._resetsmallModuleCommodityModel();
    },
    // 隐藏小编辑框
    _hideSmallModuleEditBox() {
      this.isShowSmallModuleEditBox = false;
    },
    // 更新页面模块列表
    _updateModuleListData(needUpdateModuleIndex, newModuleData) {
      this.moduleList.splice(needUpdateModuleIndex, 1, newModuleData);
    },
    // 新增专栏
    _addColumn(data) {
      dbMall.addColumn(data).then(res => {
        if (res.success) {
          // 记录新增的专栏 id
          this.newColumnId = res.result;
          this._successAddColumnTip();
        } else {
          // 新增专栏失败
          this.newColumnId = 0;
          this._failAddColumnTip(res.message);
        }
      });
    },
    // 更新栏目
    _updateColumn(data) {
      dbMall.updateColumn(data).then(res => {
        if (res.success) {
          // 更新专栏成功
          this._successUpdateColumnTip();
        } else {
          // 更新专栏失败
          this._failUpdateColumnTip(res.message);
        }
      });
    },
    _successAddColumnTip() {
      this.$message({
        message: "新增专栏成功",
        center: true,
        type: "success",
        duration: 1000
      });
    },
    _failAddColumnTip(message) {
      this.$message({
        message: message,
        center: true,
        type: "error",
        duration: 1000
      });
    },
    _successUpdateColumnTip() {
      this.$message({
        message: "更新专栏成功",
        center: true,
        type: "success",
        duration: 1000
      });
    },
    _failUpdateColumnTip(message) {
      this.$message({
        message: message,
        center: true,
        type: "error",
        duration: 1000
      });
    },
    // 过滤用户编辑模块时保存空数据的行为
    _invalidModuleInfoTip() {
      this.$alert("不允许保存空数据！", "操作提示", {
        confirmButtonText: "确定",
        type: "warning",
        center: true
      });
      return false;
    },
    _getColumnInfoById(columnId) {
      dbMall
        .getColumnInfoById(columnId)
        .then(res => {
          if (res.success) {
            console.log("获取详细模块成功--", res.result);
            let { name, path, status, inVisitor } = res.result;
            // 专栏：名称、路径、是否展示
            this.columnInfo.barName = name;
            this.columnInfo.barPath = path;
            this.columnInfo.status = status;
            this.columnInfo.isTouristsVisible = inVisitor;
            // 专栏详情的模块个数
            this.moduleNumOfEditedColumn = res.result.topModuleInfoList.length;
            console.log(
              "从服务器加载的模块个数--",
              this.moduleNumOfEditedColumn
            );
            let arr = []
            res.result.topModuleInfoList.map((item, index) => {
              // 模块id
              let moduleId = item.id;
              // 模块详情
              let moduleInfo = JSON.parse(item.details);
              moduleInfo.moduleId = moduleId;
              if (moduleInfo.type === moduleTypeEnum.bigModule) {
                // 添加一个大模块
                this.$refs.addBigModuleBtn.click();
              } else if (moduleInfo.type === moduleTypeEnum.smallModule) {
                // 添加一个小模块
                this.$refs.addSmallModuleBtn.click();
              }
              // this.moduleList.push(moduleInfo);
              arr.push(moduleInfo);
            });
            this.moduleList = arr
            console.log("当前模块数据列表--", this.moduleList);
            // 根据moduleList中的数据展示预览信息
            let targetTplList = document.querySelectorAll(".module-tpl");
            this.moduleList.map((item, index) => {
              let targetIndex = 2 + index;
              let targetModuleEle = targetTplList[targetIndex];
              // 大模块数据左侧预览
              if (item.type === moduleTypeEnum.bigModule) {
                console.log("大模块");
                // 先把非预览下的按钮文字隐藏掉
                let bigModulePreEle = targetModuleEle.children[0];
                bigModulePreEle.children[0].style.display = "none";
                // 六种预览模式
                let posterImgEle = bigModulePreEle.children[1];
                let carouselImgEle = bigModulePreEle.children[2];
                let bannerImgEle = bigModulePreEle.children[3];
                let commodityUlEle = bigModulePreEle.children[4];
                let promotionUlEle = bigModulePreEle.children[5];
                let richTextEle = bigModulePreEle.children[6];
                let goodsList;
                switch (item.data.infoType) {
                  case moduleInfoTypeEnum.picture:
                    // 图片类型
                    console.log("图片");
                    switch (item.data.moduleInfo.type) {
                      case moduleImgInfoTypes.poster:
                        // 是海报图
                        posterImgEle.style.display = "block";
                        posterImgEle.src = item.data.moduleInfo.data[0].imgSrc;
                        break;
                      case moduleImgInfoTypes.carousel:
                        carouselImgEle.style.display = "block";
                        carouselImgEle.src =
                          item.data.moduleInfo.data[0].imgSrc;
                        break;
                      case moduleImgInfoTypes.banner:
                        bannerImgEle.style.display = "block";
                        bannerImgEle.src = item.data.moduleInfo.data[0].imgSrc;
                        break;
                      default:
                        break;
                    }
                    break;
                  case moduleInfoTypeEnum.generalGood:
                    // 普通商品类型
                    console.log("普通商品");
                    commodityUlEle.style.display = "flex";
                    goodsList = item.data.moduleInfo.data;
                    goodsList.map((item, index) => {
                      let commodityLiEle = commodityUlEle.children[index];
                      commodityLiEle.style.display = "block";
                      let commodityImgEle = commodityLiEle.children[0];
                      commodityImgEle.setAttribute("src", item.commodityImg);
                      let commodityNameEle = commodityLiEle.children[1];
                      commodityNameEle.textContent = item.commodityName.substring(
                        0,
                        5
                      );
                      let commodityPriceEle = commodityLiEle.children[2];
                      commodityPriceEle.textContent = `￥${item.retailPrice}`;
                    });
                    break;
                  case moduleInfoTypeEnum.promotionalGood:
                    // 促销商品
                    promotionUlEle.style.display = "flex";
                    let promotionGoodUlEle = promotionUlEle.children[1];
                    // 商品列表
                    goodsList = item.data.moduleInfo.data;
                    goodsList.map((item, index) => {
                      if (index < 5) {
                        let commodityLiEle = promotionGoodUlEle.children[index];
                        commodityLiEle.style.display = "flex";
                        let commodityImgEle = commodityLiEle.children[0];
                        commodityImgEle.setAttribute("src", item.commodityImg);
                        let commodityNameEle = commodityLiEle.children[1];
                        commodityNameEle.textContent = item.commodityName.substring(
                          0,
                          5
                        );
                      }
                    });
                    break;
                  case moduleInfoTypeEnum.richText:
                    // 富文本
                    console.log("富文本预览", item.data.moduleInfo.data);
                    richTextEle.style.display = "block";
                    richTextEle.innerHTML = item.data.moduleInfo.data;
                    break;
                  default:
                    break;
                }
              } else if (item.type === moduleTypeEnum.smallModule) {
                // 小模块数据--三个子数据
                console.log("小模块");
                let smallModuleDataList = item.data;
                smallModuleDataList.map((item, index) => {
                  if (!item) {
                    // 空数据抛弃
                    return;
                  }
                  // div.small-module-child
                  let smallModuleChild = targetModuleEle.children[index];
                  // 先把非预览下的按钮文字隐藏掉
                  smallModuleChild.children[0].style.display = "none";
                  // 四种预览模式
                  let posterImgEle = smallModuleChild.children[1];
                  let postersContainerEle = smallModuleChild.children[2];
                  let carouselImgEle = smallModuleChild.children[3];
                  let commodityUlEle = smallModuleChild.children[4];
                  if (item.infoType === moduleInfoTypeEnum.picture) {
                    // 图片
                    switch (item.moduleInfo.type) {
                      case moduleImgInfoTypes.poster:
                        // 海报图预览
                        let posterImgNum = item.moduleInfo.data.length;
                        if (posterImgNum === 1) {
                          // 一张海报图
                          posterImgEle.style.display = "block";
                          posterImgEle.src = item.moduleInfo.data[0].imgSrc;
                        } else if (posterImgNum === 2) {
                          // 两张海报图
                          postersContainerEle.style.display = "flex";
                          let firstPosterImg = postersContainerEle.children[0];
                          firstPosterImg.src = item.moduleInfo.data[0].imgSrc;
                          let secondPosterImg = postersContainerEle.children[1];
                          secondPosterImg.src = item.moduleInfo.data[1].imgSrc;
                        }
                        break;
                      case moduleImgInfoTypes.carousel:
                        carouselImgEle.style.display = "block";
                        carouselImgEle.src = item.moduleInfo.data[0].imgSrc;
                        break;
                      default:
                        break;
                    }
                  } else if (item.infoType === moduleInfoTypeEnum.generalGood) {
                    // 商品
                    commodityUlEle.style.display = "flex";
                    let goodsList = item.moduleInfo.data;
                    goodsList.map((item, index) => {
                      let commodityLiEle = commodityUlEle.children[index];
                      commodityLiEle.style.display = "flex";
                      let commodityImgEle = commodityLiEle.children[0];
                      commodityImgEle.setAttribute("src", item.commodityImg);
                      let commodityNameEle = commodityLiEle.children[1];
                      commodityNameEle.textContent = item.commodityName.substring(
                        0,
                        5
                      );
                    });
                  }
                });
              }
            });
            console.log(this.moduleList);
          } else {
            console.log("查询失败--", res.message);
          }
        })
        .catch(e => {
          console.log("获取信息模块异常", e);
        });
    },
    _successAddModuleForColumnTip() {
      this.$message({
        message: "新增模块保存成功",
        center: true,
        type: "success",
        duration: 1000
      });
    },
    _failAddModuleForColumnTip() {
      this.$message({
        message: "新增模块保存失败，请重试",
        center: true,
        type: "error",
        duration: 1000
      });
    },
    _successUpdateModuleForColumnTip() {
      this.$message({
        message: "模块详情更新成功",
        center: true,
        type: "success",
        duration: 1000
      });
    },
    _failUpdateModuleForColumnTip() {
      this.$message({
        message: "模块详情更新失败，请重试",
        center: true,
        type: "error",
        duration: 1000
      });
    },
    _successDeleteModuleForColumnTip() {
      this.$message({
        message: "模块删除成功",
        center: true,
        type: "success",
        duration: 1000
      });
    },
    _failDeleteModuleForColumnTip() {
      this.$message({
        message: "模块删除失败，请重试",
        center: true,
        type: "error",
        duration: 1000
      });
    },
    _addModuleForColumn(data) {
      dbMall
        .addModuleForColumn(data)
        .then(res => {
          if (res.success) {
            console.log("新加栏目成功");
            // 新加模块的id
            let moduleId = res.result;
            // 当前被编辑的数据
            let newData = this.moduleList[this.currentModuleIndex];
            newData.moduleId = moduleId;
            this._updateModuleListData(this.currentModuleIndex, newData);
            this._successAddModuleForColumnTip();
          } else {
            console.log("新加栏目失败");
            this._successAddModuleForColumnTip();
          }
        })
        .catch(e => {
          console.log("新加栏目失败");
          this._successAddModuleForColumnTip();
        });
    },
    _updateModuleForColumn(data) {
      dbMall
        .updateModuleForColumn(data)
        .then(res => {
          if (res.success) {
            // 更新成功
            console.log("更新栏目成功");
            this._successUpdateModuleForColumnTip();
          } else {
            // 更新失败
            console.log("更新栏目失败");
            this._failUpdateModuleForColumnTip();
          }
        })
        .catch(e => {
          // 更新失败
          console.log("更新栏目异常", e);
          this._failUpdateModuleForColumnTip();
        });
    },
    _deleteModuleInColumn(moduleId, columnId) {
      dbMall
        .deleteModuleInColumn(moduleId, columnId)
        .then(res => {
          if (res.success) {
            // 删除成功--这个时候去更新页面的moduleList
            this.moduleList.splice(this.currentModuleIndex, 1);
            // 更新数据后还要删除该DOM节点
            this.$refs.modules.removeChild(this.willRemoveModuleEle);
            // 隐藏编辑框
            this._hideBigModuleEditBox();
            this._successDeleteModuleForColumnTip();
          } else {
            // 删除失败--不要变动页面的moduleList
            this._failDeleteModuleForColumnTip();
          }
        })
        .catch(e => {
          // 删除失败
          this._failDeleteModuleForColumnTip();
        });
    },
    // 获取商品弹框相关信息
    _getCommodityDialogInfo() {
      // 获取所有商品分类信息
      this._getGoodsTypeList();
      // 获取弹框商品列表
      // this._getGoodsList();
    },

    prev(index, row) {
      if (index == 0) return;
      let arr = [...this.bigModuleCarouselModel.moduleInfo.data]
      arr.splice(index, 1)
      arr.splice(index - 1, 0, row)
      this.bigModuleCarouselModel.moduleInfo.data = arr
    },
    next(index, row) {
      let arr = [...this.bigModuleCarouselModel.moduleInfo.data]
      if (index == arr.length - 1) return
      arr.splice(index, 1)
      arr.splice(index + 1, 0, row)
      this.bigModuleCarouselModel.moduleInfo.data = arr
    }
  },
  created() {
    if (this.$route.query.id) {
      // 更新专栏
      this.pageModule = pageModules.updateColumn;
      this.editedColumnId = this.$route.query.id;
      this._getColumnInfoById(this.editedColumnId);
    } else {
      // 新增专栏
      this.pageModule = pageModules.addColumn;
    }
  },
  mounted() {
    this.rowDrop();
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.titles.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.titles.clientWidth + paddingWidth + "px";
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
    Editor
  }
};
</script>

<style lang="scss" scoped>
.add-mall-top {
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: rgba(96, 98, 102, 1);
  .titles {
    display: flex;
    height: 48px;
    .container {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: rgba(255, 255, 255, 1);
    }
  }
  .edit-bar {
    .left {
      background: #3d74f2;
      cursor: pointer;
    }
    .right {
      background: #c0c4cc;
      cursor: pointer;
    }
  }
  .edit-page {
    .left {
      background: #c0c4cc;
      cursor: pointer;
    }
    .right {
      background: #3d74f2;
      cursor: pointer;
    }
  }
  .bar-edit-container {
    margin-top: 24px;
    .item {
      display: flex;
    }
  }
  .page-edit-container {
    margin-top: 24px;
    .module-edit {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      .module-area {
        width: 600px;
        padding-bottom: 40px;
        .modules {
          width: 100%;
          position: relative;
          /* 大模块编辑框样式 */
          .big-module-edit-box {
            width: 124%;
            box-sizing: border-box;
            border: 1px solid #eaeef5;
            padding: 10px 32px 16px 32px;
            background: #eaeef5;
            position: absolute;
            /* 伪元素制作文字气泡 */
            &::before,
            &::after {
              content: "";
              display: block;
              border-width: 20px;
              position: absolute;
              top: 100px;
              left: -40px;
              border-style: solid dashed dashed;
              border-color: transparent #eaeef5 transparent transparent;
              font-size: 0;
              line-height: 0;
            }
            &::after {
              left: -38px;
              border-color: transparent #eaeef5 transparent transparent;
            }
            .desc {
              font-size: 16px;
              color: rgba(96, 98, 102, 1);
            }
            .module-type {
              margin-top: 12px;
              margin-bottom: 12px;
              .desc {
                font-size: 14px;
                color: rgba(96, 98, 102, 1);
              }
              .item {
                margin: 0;
              }
            }
            .module-type-image {
              .image-type {
                .desc {
                  font-size: 14px;
                  color: rgba(96, 98, 102, 1);
                }
              }
              .poster-banner-img-upload-area {
                margin-top: 36px;
                margin-bottom: 16px;
                padding: 10px;
                background: #fff;
                /* 图片上传成功预览样式 */
                .uploaded-img {
                  width: 100%;
                  height: 120px;
                }
                .add-link {
                  display: flex;
                  margin: 10px 0;
                  .desc {
                    width: 80px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    color: rgba(96, 98, 102, 1);
                  }
                  .gray {
                    width: 240px;
                  }
                }
                .tip {
                  font-size: 12px;
                  color: rgba(144, 147, 153, 1);
                }
              }
              .carousel-img-upload-area {
                margin-top: 36px;
                margin-bottom: 10px;
                padding: 10px;
                background: #fff;
                position: relative;
                /* 图片上传成功预览样式 */
                .uploaded-img {
                  width: 100%;
                  height: 120px;
                }
                .add-link {
                  display: flex;
                  margin: 10px 0;
                  .desc {
                    width: 80px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    color: rgba(96, 98, 102, 1);
                  }
                  .gray {
                    width: 240px;
                  }
                }
                .delete-btn {
                  position: absolute;
                  top: -20px;
                  right: 0;
                  width: 20px;
                  height: 20px;
                  font-size: 20px;
                  display: flex;
                  justify-content: center;
                  align-content: center;
                  border: 1px dashed gray;
                  border-radius: 50%;
                  cursor: pointer;
                }
              }
              .btn-tip {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 12px;
                color: rgba(144, 147, 153, 1);
                margin-bottom: 10px;
                .btn {
                  margin-right: 6px;
                  color: #3d74f2;
                  cursor: pointer;
                }
              }
            }
            .module-type-commodity {
              .commodity-area {
                background: #fff;
                .table-img {
                  .table-container {
                    .delete-btn {
                      font-size: 12px;
                      color: rgba(61, 116, 242, 1);
                      cursor: pointer;
                      .commodity-classify {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      }
                    }
                  }
                }
                .add-btn {
                  display: inline-block;
                  padding: 6px 0 6px 26px;
                  font-size: 12px;
                  color: rgba(61, 116, 242, 1);
                  cursor: pointer;
                }
              }
            }
            .cancel-save-btns {
              width: 100%;
              height: 40px;
              margin-top: 16px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          /* 小模块编辑框样式 */
          .small-module-edit-box {
            width: 520px;
            box-sizing: border-box;
            border: 1px solid #eaeef5;
            padding: 10px 32px 16px 32px;
            background: #eaeef5;
            position: absolute;
            /* 伪元素制作文字气泡 */
            &::before,
            &::after {
              content: "";
              display: block;
              border-width: 20px;
              position: absolute;
              top: 100px;
              left: -40px;
              border-style: solid dashed dashed;
              border-color: transparent #eaeef5 transparent transparent;
              font-size: 0;
              line-height: 0;
            }
            &::after {
              left: -38px;
              border-color: transparent #eaeef5 transparent transparent;
            }
            .desc {
              font-size: 16px;
              color: rgba(96, 98, 102, 1);
            }
            .module-type {
              margin-top: 12px;
              margin-bottom: 12px;
              .desc {
                font-size: 14px;
                color: rgba(96, 98, 102, 1);
              }
            }
            .module-type-image {
              .image-type {
                .desc {
                  font-size: 14px;
                  color: rgba(96, 98, 102, 1);
                }
              }
              .image-count {
                margin-top: 12px;
                .desc {
                  font-size: 14px;
                  color: rgba(96, 98, 102, 1);
                }
              }
              .poster-img-upload-area {
                margin-top: 36px;
                margin-bottom: 16px;
                .img-upload-container {
                  display: flex;
                  padding: 10px;
                  background: #fff;
                  &:first-child {
                    margin-bottom: 10px;
                  }
                  .link-tip-container {
                    margin-left: 8px;
                    .add-link {
                      display: flex;
                      flex-direction: column;
                      margin: 10px 0;
                      .desc {
                        width: 80px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 14px;
                        color: rgba(96, 98, 102, 1);
                        margin-bottom: 10px;
                      }
                      .gray {
                        width: 240px;
                      }
                    }
                    .tip {
                      font-size: 12px;
                      color: rgba(144, 147, 153, 1);
                    }
                  }
                }
              }
              .carousel-img-upload-area {
                margin-top: 36px;
                margin-bottom: 10px;
                padding: 10px;
                background: #fff;
                position: relative;
                .img-uploaded {
                  width: 100%;
                  height: 120px;
                }
                .add-link {
                  display: flex;
                  margin: 10px 0;
                  .desc {
                    width: 80px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    color: rgba(96, 98, 102, 1);
                  }
                  .gray {
                    width: 240px;
                  }
                }
                .delete-btn {
                  position: absolute;
                  top: -20px;
                  right: 0;
                  width: 20px;
                  height: 20px;
                  font-size: 20px;
                  display: flex;
                  justify-content: center;
                  align-content: center;
                  border: 1px dashed gray;
                  border-radius: 50%;
                  cursor: pointer;
                }
              }
              .btn-tip {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 12px;
                color: rgba(144, 147, 153, 1);
                margin-bottom: 10px;
                .btn {
                  margin-right: 6px;
                  color: #3d74f2;
                  cursor: pointer;
                }
              }
            }
            .module-type-commodity {
              .commodity-area {
                background: #fff;
                .table-img {
                  .table-container {
                    .delete-btn {
                      font-size: 12px;
                      color: rgba(61, 116, 242, 1);
                      cursor: pointer;
                    }
                  }
                }
                .add-btn {
                  display: inline-block;
                  padding: 6px 0 6px 26px;
                  font-size: 12px;
                  color: rgba(61, 116, 242, 1);
                  cursor: pointer;
                }
              }
            }
            .cancel-save-btns {
              margin-top: 16px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          /* 大模块节点复制添加到文档后的样式 */
          .big-module {
            box-sizing: border-box;
            height: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 16px;
            border-radius: 4px;
            border: 1px solid rgba(192, 196, 204, 1);
            cursor: pointer;
            position: relative;
            .big-module-content {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              .preview-commodity-list {
                box-sizing: border-box;
                padding: 6px 6px;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: flex-start;
                .preview-commodity {
                  box-sizing: border-box;
                  border: 1px dotted #939393;
                  width: 18%;
                  margin: 0 6px;
                  display: flex;
                  flex-direction: column;
                  .commodity-name {
                    height: 28px;
                    margin: 16px 0 12px 0;
                    font-size: 14px;
                  }
                  .commodity-price {
                    display: flex;
                    justify-content: flex-start;
                    padding-left: 6px;
                    font-size: 12px;
                  }
                }
              }
            }
            .big-module-delete-btn {
              position: absolute;
              top: -10px;
              right: -26px;
              width: 20px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 20px;
              border: 1px dashed gray;
              border-radius: 50%;
              cursor: pointer;
            }
          }
          /* 小模块节点复制添加到文档后的样式 */
          .small-module {
            box-sizing: border-box;
            height: 200px;
            display: flex;
            padding: 8px 10px;
            margin-bottom: 16px;
            border-radius: 4px;
            border: 1px solid rgba(192, 196, 204, 1);
            cursor: pointer;
            position: relative;
            .small-module-child {
              box-sizing: border-box;
              width: 33%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 8px;
              border: 1px dotted #a2a2a2;
              .preview-poster-img-container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
              }
              .preview-commodity-list {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                .preview-commodity {
                  box-sizing: border-box;
                  margin: 2px;
                  width: 46%;
                  height: 46%;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  border: 1px dotted #939393;
                  .commodity-name {
                    margin-top: 4px;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    font-size: 12px;
                  }
                }
              }
              &:last-child {
                margin-right: 0;
              }
            }
            .small-module-delete-btn {
              position: absolute;
              top: -10px;
              right: -26px;
              width: 20px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 20px;
              border: 1px dashed gray;
              border-radius: 50%;
              cursor: pointer;
            }
          }
        }
        .add-module {
          box-sizing: border-box;
          height: 160px;
          display: flex;
          flex-direction: column;
          padding: 4px 16px 16px 16px;
          border-radius: 4px;
          border: 1px solid rgba(192, 196, 204, 1);
          .desc {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 20px;
            font-size: 14px;
            color: rgba(96, 98, 102, 1);
          }
          .line {
            margin-top: 4px;
            margin-bottom: 15px;
            height: 1px;
            background: #c0c4cc;
          }
          .module-list {
            display: flex;
            height: 100px;
            .add-big-module {
              flex-grow: 1;
              border: 1px solid rgba(192, 196, 204, 1);
              margin-right: 16px;
              cursor: pointer;
            }
            .add-small-module {
              box-sizing: border-box;
              flex-grow: 1;
              display: flex;
              padding: 4px 5px;
              border: 1px solid rgba(192, 196, 204, 1);
              cursor: pointer;
              .item {
                flex-grow: 1;
                border: 1px dotted rgba(192, 196, 204, 1);
                margin-right: 4px;
                &:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }
      }
      .edit-area {
        flex-grow: 1;
        margin-left: 24px;
        padding-bottom: 40px;
      }
    }
  }
  .operations {
    height: 60px;
    position: fixed;
    left: 256px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
  }
  .add-commodity-container {
    .select-search-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 16px;
      .commodity-type {
        margin-right: 12px;
      }
      .btn-blue {
        margin-left: 10px;
        width: 100px;
        height: 32px;
      }
    }
    .table-img {
      .table-container {
        .commodity-classify {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          line-height: 20px;
        }
        .outside-container {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .inner-container {
            margin-right: 16px;
          }
        }
      }
    }
    .pagination-container {
      box-sizing: border-box;
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 20px;
    }
    .commodity-operations {
      margin-top: 16px;
      display: flex;
      justify-content: center;
      .btn-white {
        margin-right: 24px;
      }
    }
  }
}
/* 大模块--页面预览样式 */
.big-module-content {
  /* 大模块--非预览模式 */
  .btn-desc {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* 大模块--海报图预览 */
  .prev-img-poster {
    display: none;
  }
  /* 大模块--轮播图首图预览 */
  .prev-img-carousel {
    display: none;
  }
  /* 大模块--横幅条预览 */
  .prev-img-banner {
    display: none;
  }
  /* 普通商品预览 */
  .preview-commodity-list {
    display: none;
  }
  /* 促销商品预览 */
  .preview-promotion-container {
    box-sizing: border-box;
    padding: 12px 12px 20px 12px;
    width: 100%;
    height: 100%;
    display: none;
    flex-direction: column;
    justify-content: space-between;
    .desc-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .desc {
        font-size: 14px;
        white-space: nowrap;
      }
      .btn-desc {
        width: 50px;
        height: 20px;
        .previous {
          position: relative;
          width: 50%;
          height: 20px;
          border: 1px solid #e3e3e3;
          border-right: none;
          cursor: pointer;
        }
        .previous::before {
          content: "";
          width: 6px;
          height: 6px;
          border: solid #bcbcbc;
          border-width: 2px 0 0 2px;
          transform: translate(-50%, -50%) rotate(-45deg);
          position: absolute;
          left: 50%;
          top: 50%;
        }
        .next {
          position: relative;
          width: 50%;
          height: 20px;
          border: 1px solid #e3e3e3;
          cursor: pointer;
        }
        .next::before {
          content: "";
          width: 6px;
          height: 6px;
          border: solid #bcbcbc;
          border-width: 0 2px 2px 0;
          transform: translate(-50%, -50%) rotate(-45deg);
          position: absolute;
          left: 50%;
          top: 50%;
        }
      }
    }
    .preview-promotion-list {
      margin-top: 10px;
      .preview-commodity {
        width: 106px;
        height: 150px;
        margin-right: 12px;
        background-color: #f7f7f7;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .commodity-name {
          width: 100%;
          margin-top: 20px;
          padding-left: 6px;
        }
      }
      .preview-commodity:last-child {
        margin-right: 0;
      }
    }
  }
  .preview-rich-text {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: auto;
    padding: 10px;
  }
}

/* 轮播图排序 */
.banner-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .sort {
    cursor: pointer;
    color: #999;
    font-size: 14px;
    .prev {
      margin-right: 10px;
    }
  }
}
</style>

<style lang="scss">
#addMallTop {
  .el-form {
    .el-form-item {
      .el-form-item__label {
        width: 120px;
      }
    }
  }
  /* 大模块编辑框图片上传区域样式 */
  .big-module-edit-box {
    .module-type-image {
      /* 海报图 轮播图 横幅条 */
      .el-upload {
        width: 100%;
        .el-upload-dragger {
          width: 100%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2px;
          .el-upload__text {
            font-size: 12px;
            color: rgba(61, 116, 242, 1);
          }
        }
      }
      .el-upload-list {
        display: none;
      }
    }
    .module-type-richtext {
      #wangeditor {
        .w-e-text-container {
          height: 400px !important;
          background-color: #fff;
        }
      }
    }
  }
  /* 小模块编辑框图片上传区域样式 */
  .small-module-edit-box {
    .module-type-image {
      /* 海报图 */
      .poster-img-upload-area {
        .el-upload {
          .el-upload-dragger {
            width: 120px;
            height: 120px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            .el-upload__text {
              font-size: 12px;
              color: rgba(61, 116, 242, 1);
            }
          }
        }
        .el-upload-list {
          display: none;
        }
      }
      /* 轮播图 */
      .carousel-img-upload-area {
        .el-upload {
          width: 100%;
          .el-upload-dragger {
            width: 100%;
            height: 120px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            .el-upload__text {
              font-size: 12px;
              color: rgba(61, 116, 242, 1);
            }
          }
        }
        .el-upload-list {
          display: none;
        }
      }
    }
  }
  .el-select.gray {
    width: 96px;
    .el-input {
      width: 96px;
      .el-input__inner {
        width: 96px;
      }
    }
  }
  .el-input.gray {
    width: 180px;
    .el-input__inner {
      width: 180px;
      padding-left: 8px;
    }
  }
  .el-input.gray.column-amount {
    width: 80px;
    .el-input__inner {
      width: 80px;
      padding-left: 8px;
    }
  }
  .el-radio-group {
    .el-radio {
      width: 80px;
    }
  }
}
</style>
